<template>
  <div class="dashboard">
    <v-btn @click="addNewOrder()" fab absolute right class="mr-4" top small color="secondary" style="top: -17px;" dark>
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog
      v-model="loading"
      persistent
      width="600"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <v-card color="secondary" v-if="!embed"> 
      <v-card-text TOPSPLASH SEARCHSTATS>
        <v-layout
          align-center
          justify-center
          wrap
        >
          <v-flex v-if="!userRole || userRole != 'admin'" xs12 md4 mt-1 pa-1>
            <v-text-field
              label="Search by Phone Number"
              solo
              hide-details
              clearable
              v-model.trim="searchPhoneNumber"
            >
            </v-text-field>
          </v-flex>
          <v-flex v-if="!userRole || userRole != 'admin'" xs12 md2 mt-1 pa-1>
            <v-btn 
              color="white" 
              :disabled="!searchPhoneNumber || searchPhoneNumber == ''" 
              @click="getLeadsBySearch()" 
              large 
              >Search
            </v-btn>
          </v-flex>
          <v-flex v-if="!userRole || userRole != 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
          <v-flex v-if="!userRole || userRole != 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md4 mt-1 pa-1>
            <v-text-field
              label="Search by Phone Number"
              solo
              hide-details
              clearable
              v-model.trim="searchPhoneNumber"
            >
            </v-text-field>
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md2 mt-1 pa-1>
            <v-btn 
              color="white"
              block
              :disabled="!searchPhoneNumber || searchPhoneNumber == ''" 
              @click="getLeadsBySearch()" 
              large 
              >Search
            </v-btn>
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md2 mt-1 pa-1>
            <v-autocomplete
              :items="searchCats"
              v-model="selectedSearchCat"
              label="Search By"
              solo
              hide-details
              return-object
              clearable
              :loading="loading"
            ></v-autocomplete>
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md4 mt-1 pa-1>
            <v-text-field
              label="Search..."
              solo
              hide-details
              clearable
              v-model.trim="searchText"
              @input="filterLeads()"
            >
            </v-text-field>
          </v-flex>
          <v-flex v-if="userRole == 'admin'" xs12 md3 pa-1 class="text-xs-center">
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    
    <v-progress-linear v-if="loading" style="margin-top:0;margin-bottom:0;" :indeterminate="true"></v-progress-linear>
    <v-card v-if="userRole == 'admin' && !embed" ADMIN FILTERS>
      <v-layout row wrap px-5 pb-3>
        <v-flex xs6 md2 px-1 mb-0>
          <v-autocomplete
            :items="orderstatusesLoaded"
            v-model="selectedTLStatus"
            label="Select a Status"
            return-object
            clearable
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="fsd"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fTLDate"
                label="From Status Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="fTLDate" @input="fsd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="tsd"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tTLDate"
                label="To Status Date"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tTLDate" @input="tsd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mb-0>
          <v-autocomplete
            :items="shippingstatusesLoaded"
            v-model="selectedSHIStatus"
            label="Select a Shipping Status"
            return-object
            clearable
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="fshid"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fSHIDate"
                label="From Shipping Status Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="fSHIDate" @input="fshid = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="tshid"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tSHIDate"
                label="To Shipping Status Date"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tSHIDate" @input="tshid = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mt-1>
          <v-menu
            v-model="fud"
            :close-on-content-click="false"
            :nudge-right="40"
            :allowed-dates="fromDates"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fUpdateDate"
                label="From Update Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="fUpdateDate" @input="fud = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mt-1>
          <v-menu
            v-model="tud"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tUpdateDate"
                label="To Update Date"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tUpdateDate" @input="tud = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mt-1>
          <v-menu
            v-model="fd"
            :close-on-content-click="false"
            :nudge-right="40"
            :allowed-dates="fromDates"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fDate"
                label="From Import Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="fDate" @input="fd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mt-1>
          <v-menu
            v-model="td"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tDate"
                label="To  Import Date"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tDate" @input="td = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mb-0>
          <v-autocomplete
            :items="['No Country', ...countries]"
            v-model="selectedCountries"
            label="Select a country"
            return-object
            clearable
            multiple
            chips
            deletable-chips
            small-chips
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md3 px-1 mb-0>
          <v-autocomplete
            :items="['No Campaign', ...campaigns]"
            v-model="selectedCampaign"
            label="Select a campaign"
            return-object
            clearable
            multiple
            hide-details
            chips
            deletable-chips
            small-chips
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md3 px-1 mb-0>
          <v-autocomplete
            :items="['No Code', ...companycodes]"
            v-model="selectedCompanyCodes"
            label="Select Company Code"
            return-object
            clearable
            multiple
            chips
            deletable-chips
            small-chips
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md3 px-1 mb-0>
          <v-autocomplete
            :items="['No Source', ...referrers]"
            v-model="selectedReferrer"
            label="Select a source"
            return-object
            clearable
            multiple
            chips
            deletable-chips
            small-chips
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 px-1>
          <v-autocomplete
            :items="['No Status', ...orderstatusesLoaded]"
            v-model="nselect"
            label="Filter by Order Status"
            clearable
            hide-details
            multiple
            chips
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 px-1>
          <v-autocomplete
            :items="['No Status', ...shippingstatusesLoaded]"
            v-model="shiselect"
            label="Filter by Shipping Status"
            clearable
            hide-details
            multiple
            chips
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 px-1>
          <v-autocomplete
            :items="['No Status', ...deliverystatusesLoaded]"
            v-model="deliveryselect"
            label="Filter by Delivery Status"
            clearable
            hide-details
            multiple
            chips
            deletable-chips
            small-chips
            item-text="en"
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md3 px-1>
          <v-select
            :items="['No Document Number', 'Document Number']"
            v-model="docNumber"
            label="Filter by Document Number"
            clearable
            hide-details
            chips
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-select>
        </v-flex>
        <v-flex xs12 md3 px-1>
          <v-autocomplete
            :items="[...usersLoaded]"
            v-model="userselectcreate"
            v-if="usersLoaded && usersLoaded.length !=0"
            label="Filter by Creator Agents"
            chips
            clearable
            hide-details
            multiple
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md4 px-1>
          <v-autocomplete
            :items="getItems('product')"
            v-model="pselect"
            v-if="productsLoaded && productsLoaded.length !=0"
            label="Filter by Products"
            chips
            multiple
            clearable
            item-value="sku"
            item-text="item_name"
            :filter="filterObject"
            hide-details
            deletable-chips
            small-chips
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md4 px-1>
          <v-autocomplete
            :items="[...usersLoaded]"
            v-model="userselect"
            v-if="usersLoaded && usersLoaded.length !=0"
            label="Filter by Agents"
            chips
            clearable
            hide-details
            multiple
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md4 px-1>
          <v-autocomplete
            :items="[...tokensLoaded]"
            v-model="selectedToken"
            v-if="tokensLoaded && tokensLoaded.length !=0"
            label="Filter by Token"
            chips
            clearable
            hide-details
            multiple
            deletable-chips
            small-chips
            return-object
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md4 px-1 mb-1>
          <v-autocomplete
            :items="deliverystatusesLoaded"
            v-model="selecteddelStatus"
            label="Select a Delivery Status"
            item-text="en"
            clearable
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="fdeld"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fdelDate"
                label="From Delivery Status Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="fdelDate" @input="fdeld = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="tdeld"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tdelDate"
                label="To Delivery Status Date"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tdelDate" @input="tdeld = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mb-1>
          <v-autocomplete
            :items="['PAID', 'FAILED', 'TRIED']"
            v-model="selectedPaidStatus"
            label="Paid"
            item-text="en"
            clearable
            multiple
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="paidd"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="paidDate"
                label="Payment Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="paidDate" @input="paidd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-menu
            v-model="tpaidd"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tpaidDate"
                label="To Payment Date"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker :min="superAdmin ? null : minDate" @change="filterLeads()" v-model="tpaidDate" @input="tpaidd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-select
            :items="['True', 'False']"
            v-model="selectedReserved"
            label="Reserved"
            clearable
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-select>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-text-field
            v-model="selectedAccountId"
            label="Account ID"
            clearable
            hide-details
            @change="filterLeads()"
            :loading="loading"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-switch label="Only K. Items" v-model="onlyKitems"></v-switch>
        </v-flex>
        <v-flex xs6 md2 px-1 mt-1>
          <v-switch label="Only Subvendor orders" v-model="onlySubvendor"></v-switch>
        </v-flex>
      </v-layout>
      <v-layout class="text-xs-center" row wrap>
        <v-flex v-if="userRole == 'admin'" xs12 md12 mt-1 pa-1>
          <v-btn 
            color="primary" 
            @click="getDataStats()" 
            large 
            v-if="superAdmin"
            >
            <v-icon left>update</v-icon>
            Get Orders Stats by filter and search
          </v-btn>
          <v-btn 
            color="primary" 
            @click="getDataStatsNew()" 
            large 
            >
            <v-icon left>update</v-icon>
            Get New DB Data
          </v-btn>
        
          <v-btn 
            color="primary" 
            @click="getLeadsToCheck()" 
            large 
            >
            <v-icon left>view_column</v-icon>
            check and edit new leads
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout row wrap py-2 v-if="!embed">
      <v-flex xs12 sm12 md12 TOP PAGGINATION>
          <div class="text-xs-center">
            <div><v-chip v-if="!loading" color="success" text-color="white">
              {{filteredLeads ? filteredLeads.length : 0}} results  
              <v-slider 
                v-if="userRole == 'admin'"
                thumb-color="red"
                thumb-label="always"
                :thumb-size="24"
                v-model="initialLoadedNumber" 
                max="500"
                hide-details 
                color="white"
                @end="()=>{
                  filterLeads();
                  getPagesNumber();
                  currentPage = 1;
                  updateVisible();
                }"
              ></v-slider>
              </v-chip></div>
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="5"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap class=" ma-2" v-if="!embed">
      <v-flex v-if="loading && false" xs12 class="text-xs-center" ma-1 LOADING>
        <v-card v-for="n in pageSize" class="elevation-4 pa-3 mt-1"  :key="n">
          <content-placeholders :rounded="true">
            <content-placeholders-heading :img="false" />
          </content-placeholders>
        </v-card>
      </v-flex>
      <v-flex xs12 ma-1 TOPBAR v-if="userRole == 'admin' && !embed">
        <v-card :class="`elevation-4 `">
          <v-layout row wrap class="px-2 pt-1">    
            <v-flex xs4 md1>
              <v-checkbox label="All" color="primary" @change="selectVisible()" v-model="selectVs" value="true" height="1" ></v-checkbox>
            </v-flex>
            <!-- <v-flex xs4 md2>
              <v-checkbox label="All results" color="primary" @change="selectVisible()" v-model="selectRs" value="true" height="1" ></v-checkbox>
            </v-flex> -->
            <v-flex xs4 md1 v-if="superAdmin">
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat 
                  icon 
                  color="secondary" 
                  @click="dialogs.delete = true" 
                  small
                  :disabled="selectedLeads.length == 0"
                  >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Delete {{selectedLeads.length}} Selected</span>
              </v-tooltip>
            </v-flex>
              <v-dialog v-model="dialogs.delete" persistent max-width="390">
                <v-card>
                  <v-card-title class="headline">Are You Sure?</v-card-title>
                  <v-card-text>
                    You are about to delete {{ selectedLeads.length }}, are you sure you want to do that?
                    <div class="error white--text pa-2 ma-3">NOTE: all data associated with {{ selectedLeads.length }} leads will be deleted completely from our servers, and it will be impossible to restore it</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="dialogs.delete = false">cancel</v-btn>
                    <v-btn 
                      color="success" 
                      outline 
                      @click="deleteB()"
                    >confirm</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            <v-flex xs4 md1>
              <v-tooltip top>
                  <v-btn 
                    slot="activator" 
                    @click="dialogs.editing = true" 
                    small 
                    flat 
                    icon 
                    color="secondary" 
                    :disabled="selectedLeads.length == 0"
                  >
                    <v-icon >loop</v-icon>
                  </v-btn>
                <span>Process {{selectedLeads.length}} Selected</span>
              </v-tooltip>
              
            </v-flex>
            <!-- <v-flex xs4 md1>
              <v-tooltip top>
                <v-btn slot="activator" 
                  flat 
                  color="secondary" 
                  small 
                  @click="exportCSV()" 
                  icon 
                  :disabled="selectedLeads.length == 0"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export {{selectedLeads.length}} Selected</span>
              </v-tooltip>
            </v-flex> -->
            <v-flex xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="changestatusdialog = true" 
                  icon 
                  :disabled="selectedLeads.length == 0"
                >
                  <v-icon>verified_user</v-icon>
                </v-btn>
                <span>Update Status {{selectedLeads.length}} Selected</span>
              </v-tooltip>
            </v-flex>
            <v-dialog v-model="changestatusdialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">Change status for {{selectedLeads.length}} Selected?</v-card-title>
                <v-card-text>
                  <v-autocomplete
                    label="Status"
                    required
                    :items="orderstatusesLoaded"
                    v-model="newStatusForAll"
                    append-outer-icon="add"
                    @click:append-outer="addstatusdialog = true"
                    >
                  </v-autocomplete>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" flat @click="changestatusdialog = false">Cancel</v-btn>
                  <v-btn color="green darken-1" flat @click="bulkStatusUpdate()">Confirm</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- <v-flex v-if="superAdmin" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="cleanDuplicates()" 
                  icon 
                >
                  <v-icon>clear_all</v-icon>
                </v-btn>
                <span>Clean Duplicates</span>
              </v-tooltip>
            </v-flex> -->
            <v-flex v-if="superAdmin" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="dialogs.bulkdelete = true" 
                  icon 
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Delete all leads</span>
              </v-tooltip>
              <v-dialog v-model="dialogs.bulkdelete" persistent max-width="390">
                <v-card>
                  <v-card-title class="headline">Are You Sure?</v-card-title>
                  <v-card-text>
                    You are about to delete all filtered leads, are you sure you want to do that?
                    <div class="error white--text pa-2 ma-3">NOTE: all data associated with all filtered leads will be deleted completely from our servers, and it will be impossible to restore it</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="dialogs.bulkdelete = false">cancel</v-btn>
                    <v-btn 
                      color="success" 
                      outline 
                      @click="deleteAll()"
                    >confirm</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAllLeads()" 
                  icon 
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export all Filtered Leads</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAllOldLeads()" 
                  icon 
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export all Old Filtered Leads</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAlleadsCourior()" 
                  icon 
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export Filtered Item Per Row</span>
              </v-tooltip>
            </v-flex>
            
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAlleadsDatePartialDate()" 
                  icon 
                  :loading="exportLoading"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export Lead Loop (DATE)</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAlleadsDatePartialDate(true)" 
                  icon 
                  :loading="exportLoading"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export Item Loop (DATE)</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="exportAlleadsDateStatusPartialDate(true)" 
                  icon 
                  :loading="exportLoading"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
                <span>Export Item Per Row (Shipping Status)</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="bulkchangestatusdialog = true" 
                  icon 
                >
                  <v-icon>verified_user</v-icon>
                </v-btn>
                <span>Change Status of all Filtered Leads</span>
              </v-tooltip>
              <v-dialog v-model="bulkchangestatusdialog" persistent max-width="700">
                <v-card>
                  <v-card-title class="headline">Change status for all filtered?</v-card-title>
                  <v-card-text>
                    <v-autocomplete
                      label="Status"
                      required
                      :items="orderstatusesLoaded"
                      v-model="newStatusForAll"
                      append-outer-icon="add"
                      @click:append-outer="addstatusdialog = true"
                      >
                    </v-autocomplete>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" flat @click="bulkchangestatusdialog = false">Cancel</v-btn>
                    <!-- <v-btn color="green darken-1" flat 
                      :disabled="!newStatusForAll"
                      :loading="loading"
                      @click="superbulkStatusUpdateOldData()"
                    >Old Data Change Confirm</v-btn> -->
                    <v-btn color="green darken-1" flat 
                      :disabled="!newStatusForAll"
                      :loading="loading"
                      @click="superbulkStatusUpdateDate()"
                    >Confirm</v-btn>
                    <v-btn color="green darken-1" flat 
                      :disabled="!newStatusForAll"
                      :loading="loading"
                      @click="superbulkStatusUpdateDate()"
                    >Confirm & download</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex v-for="b in visibleLeads" :key="b.key" xs12 ma-1>
        <v-card :class="`elevation-4`">
          <!--  -->
          <v-toolbar flat dense dark :color="`${b.ninja ? '#BE202E' : 'secondary'}`">
            <v-checkbox class="smallerScaleCheck" hide-details v-if="!b.ninja"  v-model="selectedLeads" height="1" :value="b"></v-checkbox>
            <v-toolbar-title class="white--text">{{ b.name }}
              <v-chip>{{ b.order_status }}</v-chip>
              <v-chip v-if="b.paid" label color="success" class="white--text">Paid</v-chip>
              <v-chip v-if="!b.paid && b.payment_failed" label color="error" class="white--text">Failed</v-chip>
                <span style="font-size:11px;">| </span>
                <span
                    style="font-size:11px;"
                    v-clipboard:copy="b.key"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
                  >{{b.key}}
                </span>
                <span style="font-size:14px;"> | </span>
                <span style="font-size:14px;" v-if="b.order">
                  ${{getBaseTotal(b)}}
                </span>
                <span style="font-size:14px;" v-if="b.ninja"> | </span>
                <span style="font-size:14px;" v-if="b.ninja"> {{ b.uuid }} </span>
                <span style="font-size:14px;" v-if="b.ninja"> | </span>
                <span style="font-size:14px;" v-if="b.ninja"> STORE: {{ b.business_name }} </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            
            <v-toolbar-items>
            <v-divider vertical v-if="b.allowCreate"></v-divider>
              <v-btn flat @click="() => { dialogs.editing = true; addNewOrder(b)  }" v-if="b.allowCreate">
                <v-icon left>login</v-icon>
                create
              </v-btn>
            <v-divider vertical></v-divider>
            <v-btn 
              flat
              @click="()=>{ dialogs.editing = true; selectForEdit(b)  }"
              >
              <v-icon left>loop</v-icon>
              proccess order
            </v-btn>
            <v-divider vertical></v-divider>
            <v-btn icon @click="goTo(`wa-new-chat/n/${b.wa_number ? b.wa_number : b.phone_number_1}`)">
              <v-icon>send</v-icon>
            </v-btn>
            </v-toolbar-items>
            <v-avatar
              size="14px"
              :color="getStatus(b)"
            >
            </v-avatar>
          </v-toolbar>
          <!--  -->
          <v-expansion-panel expand>
            <v-expansion-panel-content>
              <div slot="header">Order Details 
                
              </div>
              <v-card>
                <v-card-text class="py-0">
                  <v-layout row wrap>    
                    <v-flex xs6 md10>
                      <v-layout row wrap>
                        <v-flex 
                          v-for="(key, i) in basicFields.filter(f=>{
                            let n = ['order_status', 'confirm', 'processed']
                            if (n.indexOf(f) == -1) return f
                          })" 
                          :key="i" 
                          xs6 md2 pa-1>
                          <v-tooltip top>
                            <div slot="activator" class="caption grey--text ">{{ key.toUpperCase() | truncate(8,(key.length>8 ? '..': '' ) ) }}</div>
                            <span>{{ key.toUpperCase() }}</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <span slot="activator" v-if="typeof b[key] == 'string'">
                              {{ b[key] | truncate(8, (b[key] ? b[key].length>8 ? '..': '' : '' )) }}</span>
                            <span>{{ b[key] }}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs12 v-if="userRole == 'admin' && !embed">
                          <v-layout row wrap>
                            <v-flex v-if="b.status_timeline" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getTimlineArray(b.status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.update_timeline && superAdmin" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.update_timeline)"
                                    :key="event.key + event.date"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.shipping_status_timeline" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getShippingTimlineArray(b.shipping_status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.shipping_timeline" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.shipping_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.delivery_status_timeline && false" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getDeliveryTimlineArray(b.delivery_status_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                            <v-flex v-if="b.delivery_timeline" xs6 pa-1 my-1>
                              <v-timeline dense class="elevation-2">
                                <v-slide-x-reverse-transition
                                  group
                                  hide-on-leave
                                >
                                  <v-timeline-item
                                    v-for="event in getUpdateTimlineArray(b.delivery_timeline)"
                                    :key="event.key"
                                    small
                                    fill-dot
                                  >
                                    {{ event.key.split('_').join(' ').toUpperCase() }}
                                    <v-chip 
                                      color="primary"
                                      label
                                      small
                                      text-color="white"
                                    >
                                      {{ event.date | formatDate }}
                                    </v-chip>
                                    <v-chip 
                                    color="secondary" 
                                    label
                                    small
                                    text-color="white"
                                    >
                                      {{ event.agent }}
                                    </v-chip>
                                  </v-timeline-item>
                                </v-slide-x-reverse-transition>
                              </v-timeline>
                            </v-flex>
                          </v-layout> 
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs6 md2 pa-1 v-if="false">
                      <v-layout row wrap>
                        <v-flex xs12 py-1 px-2>
                          <div class="caption grey--text ">Status</div>
                          <v-tooltip top>
                            <span slot="activator">
                              <v-avatar
                                size="14px"
                                :color="getStatus(b)"
                              >
                              </v-avatar>
                            </span>
                            <span>{{ b.processed ? b.confirm ? 'Order Confirmed' : 'Order Canceled' : 'Not Processed' }}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs12 v-if="b.order && b.order.length != 0">
                          <v-tooltip top>
                            <v-chip slot="activator" color="primary" class="white--text">
                              Total: {{ getTotal(b) }}
                            </v-chip>
                            <span>Total: {{ getTotal(b) }}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>                
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    v-if="beta"
                    dark
                    color="primary"
                    @click="sendWANotification(b)"
                    >
                    n proccess order
                  </v-btn>
                  <v-btn 
                    dark
                    color="primary"
                    @click="()=>{ dialogs.editing = true; selectForEdit(b)  }"
                    >
                    proccess order
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap py-3 v-if="!embed">
      <v-flex xs12 sm12 md12 PAGGING>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="5"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
      
      
    </v-layout>
    <v-layout row wrap EDIT DIALOG>
      <v-dialog 
        persistent 
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        v-model="dialogs.editing"
        >
          <v-card>
            <v-toolbar card dark color="secondary">
              <v-btn icon dark @click="dialogs.editing = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Editing Details</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-divider vertical></v-divider>
                <v-btn dark flat @click="()=>{
                  dialogs.editing = false
                  resetEmbed()
                }">Cancel</v-btn>
                <v-divider vertical></v-divider>
                
                <!-- <v-btn dark flat :loading="loading" @click="triggerUpdate()">
                  <v-icon left>save</v-icon>
                  Save</v-btn> -->
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex v-for="l in selectedLeads" :key="l.key" xs12>
                  <v-card class="elevation-4 mb-2">
                    <v-toolbar flat dense dark color="secondary">
                      <v-toolbar-title class="white--text">{{ l.name }} | 
                        <span
                            style="font-size:11px;"
                            v-clipboard:copy="l.key"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >{{l.key}}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                      <v-divider vertical></v-divider>
                        <v-btn icon @click="goTo(`wa-new-chat/n/${l.wa_number ? l.wa_number : l.phone_number_1}`)">
                          <v-icon>send</v-icon>
                        </v-btn>
                        <v-divider vertical></v-divider>
                        <v-btn dark flat 
                          :loading="loading" 
                          v-if="(l.shipping_status != 'Out for delivery' && l.shipping_status != 'return' && l.shipping_status != 'Paid' && l.shipping_status != 'Delivered' && !l.locked) || superAdmin"
                          :disabled="(l.order_status == 'Dispatch' || l.order_status == 'Paid') && userRole != 'admin'"
                          @click="backUpdate()"
                        >
                        <v-icon left>save</v-icon>
                        Save</v-btn>
                      <v-divider vertical></v-divider>
                      </v-toolbar-items>
                      <v-avatar
                        size="14px"
                        :color="getStatus(l)"
                      >
                      </v-avatar>
                    </v-toolbar>
                    <v-layout row wrap class="pa-2">
                      <v-flex v-for="(key, i) in basicFields" :key="i"  xs12 :class="`${
                      (key == 'gender' || key == 'language') ? 'md2' : 'md4'
                      }`" px-2>
                        {{key.split('_').join(' ').toUpperCase()}} 
                        <v-text-field
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'textfield'"
                          :label="key.split('_').join(' ').toUpperCase()"
                          v-model.trim="l[key]"
                          solo
                          :clearable="!readOnly(key, l)"
                          :readonly="readOnly(key, l)"
                          :disabled="readOnly(key, l)"
                          :class="`${(readOnly(key, l)? 'tokenField' : '')}`"
                          :background-color="`${(readOnly(key, l)? 'primary' : '')}`"
                          @change="`${(key == 'phone_number_1' ? updateWAnumbers(l) : key == 'phone_number_2' ? updateWAnumbers(l) : key == 'phone_number_3' ?  updateWAnumbers(l) : null)}`"
                          :append-outer-icon="`${key == 'phone_number_2'? 'repeat' : ''}`"
                          @click:append-outer="`${key == 'phone_number_2'? switchNumbers(l) : null}`"
                        ></v-text-field>
                        <v-textarea 
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'textarea'"
                          :label="key.split('_').join(' ').toUpperCase()"
                          v-model.trim="l[key]"
                          solo
                          hide-details
                          :clearable="!readOnly(key, l)"
                          cols="30" rows="5"
                          :readonly="readOnly(key, l)"
                          :disabled="readOnly(key, l)"
                          :class="`${(readOnly(key, l)? 'tokenField' : '')}`"
                          :background-color="`${(readOnly(key, l)? 'primary' : '')}`"
                        ></v-textarea>
                        <v-btn 
                          v-if="false" 
                          color="primary" 
                          @click="()=>{
                          dialogs.map = true;
                          startMap(l.key, l.country)
                          }"
                          dark
                        >Use Google Map To Get Address</v-btn>
                        <v-autocomplete
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'select' && key != 'wa_number'"
                          :label="key.split('_').join(' ').toUpperCase()"
                          v-model="l[key]"
                          solo
                          :clearable="!readOnly(key, l)"
                          :readonly="readOnly(key, l)"
                          :items="getItems(key, l)"
                          :disabled="readOnly(key, l)"
                          @change="()=>{
                            if(key == 'agent_name') getItems(key, l);
                            if(key == 'city') initGetDeliveryFees(key, l);
                            if(key == 'sub_district') storeEnSubDistrict(key, l);
                          }"
                          :class="`${(readOnly(key, l)? 'tokenField' : '')}`"
                          :background-color="`${(readOnly(key, l)? 'primary' : '')}`"
                          :append-outer-icon="`${
                            ((((key == 'order_status' || key == 'city' || key == 'shipping_status' || key == 'failed_delivery_after_payment') && userRole == 'admin')) ? 'add' : '')
                          }`"
                          @click:append-outer="`${(key == 'order_status' ? addstatusdialog = true : key == 'city' ?  addcitydialog = true : key == 'shipping_status' ? addshippingstatusdialog = true : key == 'failed_delivery_after_payment' ? addfaileddeliverstatusdialog = true : null)}`"
                        >
                        </v-autocomplete>
                        <v-autocomplete
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'select' && key == 'wa_number'"
                          :label="key.split('_').join(' ').toUpperCase()"
                          v-model="l[key]"
                          solo
                          :clearable="!readOnly(key, l)"
                          :readonly="readOnly(key, l)"
                          :items="[l.phone_number_1, l.phone_number_2, l.phone_number_3].filter(x=> x)"
                          :loading="waLoading"
                          :disabled="readOnly(key, l)"
                          :class="`${(readOnly(key, l)? 'tokenField' : '')}`"
                          :background-color="`${(readOnly(key, l)? 'primary' : '')}`"
                          append-outer-icon="add"
                          @click:append-outer="`${(key == 'order_status' ? addstatusdialog = true : key == 'city' ?  addcitydialog = true : null)}`"
                        >
                        </v-autocomplete>
                        <v-switch 
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'switch'"
                          :label="key.split('_').join(' ').toUpperCase()"
                          v-model="l[key]"
                          :readonly="readOnly(key, l)"
                        ></v-switch>
                        <v-menu
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'date'"
                          v-model="dDate"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template slot="activator">
                            <v-text-field
                              v-model="l[key]"
                              label="Dispatch Date"
                              append-icon="event"
                              readonly
                              solo
                              clearable
                              hide-details
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="l[key]" @input="dDate = false"></v-date-picker>
                        </v-menu>
                        <v-checkbox 
                          v-if="orderFields && orderFields[key] && orderFields[key].type == 'check'"
                          :label="key.toUpperCase().split('_').join(' ')" v-model="l[key]" :value="l[key]">
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-divider ></v-divider>
                    <v-layout row wrap class="pa-2" v-if="!l.ninja" VOUCHERS>
                      <v-flex xs12 >
                        <span class="headline font-weight-bold">Voucher</span>
                      </v-flex>
                      <v-flex xs12 >
                        <v-btn color="primary" dark @click="searchVoucher(l.phone_number_1)">
                          <v-icon left>search</v-icon>
                          search for voucher</v-btn>
                      </v-flex>
                      <v-flex v-for="v in vouchers" :key="v.uid" xs12 pa-1>
                        <v-card class="pa-3 elevation-4">
                          <v-layout row wrap>
                            <v-flex v-if="v.uid" xs6 md2>
                              <div class="caption grey--text ">Voucher ID</div>
                              <v-tooltip top>
                                <span slot="activator">{{ v.uid | truncate(15, (v.uid.length>15 ? '..': '')) }}</span>
                                <span>{{ v.uid }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="v.name" xs6 md2>
                              <div class="caption grey--text ">Client Name</div>
                              <v-tooltip top>
                                <span slot="activator">{{ v.name | truncate(15, (v.name.length>15 ? '..': '')) }}</span>
                                <span>{{ v.name }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="v.phone_number_1" xs6 md2>
                              <div class="caption grey--text ">Client Phone</div>
                              <v-tooltip top>
                                <span slot="activator">{{ v.phone_number_1 | truncate(15, (v.phone_number_1.length>15 ? '..': '')) }}
                                </span>
                                <span>{{ v.phone_number_1 }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="v.issue_date" xs6 md2>
                              <div class="caption grey--text ">Issue Date</div>
                              <v-tooltip top>
                                <span slot="activator">{{ v.issue_date | truncate(15, (v.issue_date.length>15 ? '..': '')) }}</span>
                                <span>{{ v.issue_date }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="v.expiry_date" xs6 md2>
                              <div class="caption grey--text ">Expiry Date</div>
                              <v-tooltip top>
                                <span slot="activator">{{ v.expiry_date | truncate(15, (v.expiry_date.length>15 ? '..': '')) }}</span>
                                <span>{{ v.expiry_date }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex xs1 :class="`${v.active? 'success' : 'error'} text-xs-center pa-1`">
                              <span class="white--text headline">{{v.amount}}</span>
                            </v-flex>
                            <v-flex xs1 class="text-xs-center pa-1`">
                              <v-tooltip top>
                                <span slot="activator">
                                  <v-btn flat small icon color="primary" dark @click="userVoucher(l, v)">
                                    <v-icon>receipt</v-icon>
                                  </v-btn>
                                </span>
                                <span>Use Voucher</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="pa-2" v-if="!l.ninja && l.token && l.token.includes('GS_DB_') && l.form" OFFERS>
                      <v-flex xs12 @load="loadFormToLead()">
                        <span class="headline font-weight-bold">Offers</span>
                      </v-flex>
                      <v-flex xs12 pa-2>
                        <v-card v-if="!l.form.companycodes || !l.form.companycodes.length">
                          <v-flex xs12 class="text-xs-right" v-for="(off, tn) in l.form.offers" :key="'stKW'+tn">
                            {{off.text}}
                          </v-flex>
                        </v-card>
                        <v-card v-if="!l.form.companycodes || !l.form.companycodes.length">
                          <v-flex xs12 class="text-xs-right" v-for="(off, tn) in l.form.offers" :key="'stKW'+tn">
                            <div>ONLINE PRICE {{ (parseFloat(off.online_price) * parseFloat(countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].usd)).toFixed(2) }} </div>
                          </v-flex>
                        </v-card>
                        <v-card v-if="l.form.companycodes && l.form.companycodes.length">
                          <v-flex xs12 class="text-xs-right" v-for="(off, tn) in l.form.offers" :key="'stKW'+tn">
                            <v-flex xs12 class="text-xs-right" v-if="off.companycodes  && off.companycodes.filter(x=>x.company_code == l.company_code).length">
                              {{off.companycodes.filter(x=>x.company_code == l.company_code)[0].text}}
                              <div>ONLINE PRICE {{ (parseFloat(off.companycodes.filter(x=>x.company_code == l.company_code)[0].online_price) * parseFloat(countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].usd)).toFixed(2) }} </div>
                            </v-flex>
                          </v-flex>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row wrap class="pa-2" v-if="!l.ninja">
                      <v-flex xs12 >
                        <span class="headline font-weight-bold">Payment</span>
                      </v-flex>
                      <v-flex xs12>
                        <div>{{'paid'.toUpperCase().split('_').join(' ')}} : {{ l.paid }}</div>
                        <div>{{'payment_tried'.toUpperCase().split('_').join(' ')}} : {{ l.payment_tried }}</div>
                        <div>{{'payment_status'.toUpperCase().split('_').join(' ')}} : {{ l.payment_status }}</div>
                        <div>{{'payment_api_response'.toUpperCase().split('_').join(' ')}} : {{ l.payment_api_response }}</div>
                        <div>{{'payment_amount'.toUpperCase().split('_').join(' ')}} : {{ l.payment_amount }}</div>
                        <div>{{'payment_currency'.toUpperCase().split('_').join(' ')}} : {{ l.payment_currency }}</div>
                        <div>{{'payment_failed'.toUpperCase().split('_').join(' ')}} : {{ l.payment_failed }}</div>
                        <div>{{'payment_result'.toUpperCase().split('_').join(' ')}} : {{ l.payment_result }}</div>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row wrap class="pa-2">
                      <v-flex xs12>
                        <span class="headline font-weight-bold">Order</span>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-layout row wrap class="pa-2" v-if="!l.ninja">
                      <v-flex v-for="(item, i) in l.order" :key="`order-${i}`" xs12>
                        <v-layout row wrap align-center>
                          <v-flex xs3 px-2>
                            PRODUCT
                            <v-autocomplete
                              label="Product"
                              v-model="l.order[i].product"
                              solo
                              clearable
                              item-value="item_name"
                              item-text="item_name"
                              :filter="filterObject"
                              :items="getItems('product', l)"
                              @change="()=>{
                                getSKU(l, i)
                              }"
                              append-outer-icon="info"
                              @click:append-outer="()=>{
                                getDialogProduct(l, i);
                                dialogs.info = true;
                              }"
                            >
                              <template
                                  slot="prepend"
                              >
                                <v-tooltip top>
                                  <template slot="activator">
                                    <v-icon on="on" v-if="getProductNote(l, i)" color="error">warning</v-icon>
                                    
                                  </template>
                                  <div v-html="getProductNote(l, i)"></div>
                                </v-tooltip>
                              </template>
                              <template
                                  slot="item"
                                  slot-scope="{ parent, item }"
                              >
                                <v-list-tile-action>
                                  <v-icon color="primary">amp_stories</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.item_name"></v-list-tile-title>
                                  <v-list-tile-sub-title v-html="item.name_ar"></v-list-tile-sub-title>
                                  <v-list-tile-sub-title v-html="item.sku"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-avatar v-if="item.img">
                                  <img :src="item.img">
                                </v-list-tile-avatar>
                              </template>
                            </v-autocomplete>
                            <v-layout row justify-center>
                              <v-dialog v-model="dialogs.info" scrollable max-width="500px">
                                <v-card>
                                  <v-card-title>Product Info: {{ productDialogSKU }}</v-card-title>
                                  <v-divider></v-divider>
                                  <v-card-text class="text-xs-center">
                                    <img :src="productDialogImage" width="50%">
                                    <v-divider></v-divider>
                                    <span v-html="productDialogAr"></span>
                                    <v-divider></v-divider>
                                    <span v-html="productDialogEn"></span>
                                  </v-card-text>
                                  <v-divider></v-divider>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="success darken-1" :disabled="productsending" :loading="productsending" flat @click="sendProductToWA(l)">SEND TO WA</v-btn>
                                    <v-btn color="blue darken-1"  flat @click.native="dialogs.info = false">Close</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-layout>
                          </v-flex>
                          <v-flex xs2 px-2>
                            OFFER & PRICE
                            <v-autocomplete
                              label="Price"
                              v-model="l.order[i].price"
                              solo
                              clearable
                              :items="getItems('price', l, i)"
                              @change="getBasePrice(l, i)"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs2 px-2>
                            Quantity
                            <v-text-field
                              label="Quantity"
                              v-model="l.order[i].quantity"
                              solo
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 px-2>
                            Discount
                            <v-text-field
                              label="Discount"
                              v-model.trim="l.order[i].discount"
                              solo
                              @input="getBasePrice(l, i)"
                              clearable
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 px-2>
                            DOLLAR 
                            <v-text-field
                              label="Base Dollar Price"
                              v-model="l.order[i].baseprice"
                              solo
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs2 px-2>
                            SKU
                            <v-text-field
                              label="SKU"
                              v-model.trim="l.order[i].sku"
                              solo
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <v-btn @click="l.order.splice(i, 1)" icon small flat color="primary" dark>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 md4>
                        <v-btn @click="addProductToOrder(l)" color="primary" block dark>Add Product</v-btn>
                      </v-flex>
                      <v-flex v-if="l.voucher" xs12 pa-1>
                        <v-card class="pa-3 elevation-4">
                          <v-layout row wrap>
                            <v-flex v-if="l.voucher.uid" xs6 md2>
                              <div class="caption grey--text ">Voucher ID</div>
                              <v-tooltip top>
                                <span slot="activator">{{ l.voucher.uid | truncate(15, (l.voucher.uid.length>15 ? '..': '')) }}</span>
                                <span>{{ l.voucher.uid }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="l.voucher.name" xs6 md2>
                              <div class="caption grey--text ">Client Name</div>
                              <v-tooltip top>
                                <span slot="activator">{{ l.voucher.name | truncate(15, (l.voucher.name.length>15 ? '..': '')) }}</span>
                                <span>{{ l.voucher.name }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="l.voucher.phone_number_1" xs6 md2>
                              <div class="caption grey--text ">Client Phone</div>
                              <v-tooltip top>
                                <span slot="activator">{{ l.voucher.phone_number_1 | truncate(15, (l.voucher.phone_number_1.length>15 ? '..': '')) }}
                                </span>
                                <span>{{ l.voucher.phone_number_1 }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="l.voucher.issue_date" xs6 md2>
                              <div class="caption grey--text ">Issue Date</div>
                              <v-tooltip top>
                                <span slot="activator">{{ l.voucher.issue_date | truncate(15, (l.voucher.issue_date.length>15 ? '..': '')) }}</span>
                                <span>{{ l.voucher.issue_date }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex v-if="l.voucher.expiry_date" xs6 md2>
                              <div class="caption grey--text ">Expiry Date</div>
                              <v-tooltip top>
                                <span slot="activator">{{ l.voucher.expiry_date | truncate(15, (l.voucher.expiry_date.length>15 ? '..': '')) }}</span>
                                <span>{{ l.voucher.expiry_date }}</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex xs1 :class="`${l.voucher.active? 'success' : 'error'} text-xs-center pa-1`">
                              <span class="white--text headline">{{l.voucher.amount}}</span>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md8 class="text-xs-center" px-2>
                        <v-layout row wrap>
                          <v-flex xs6 class="text-xs-center" px-2>
                            <div>
                              <v-text-field
                                label="Manual Total"
                                solo
                                @keypress="isNumber($event)"
                                v-model.trim="l.manual_total"
                              ></v-text-field>
                            </div>
                            <div>
                              <v-radio-group v-model="l.add_up">
                                <v-radio label="None" :value="'add_none'"></v-radio>
                                <v-radio label="VAT" :value="'add_vat_to_total'"></v-radio>
                                <v-radio label="25 Riyal" :value="'add_25_to_total'"></v-radio>
                                <v-radio label="50 Riyal" :value="'add_50_to_total'"></v-radio>
                              </v-radio-group>
                              <v-checkbox label="Exception" v-model="l.exception" :value="true"></v-checkbox>
                              <v-checkbox label="Up" v-model="l.up" :value="true"></v-checkbox>
                              <v-checkbox label="VAT" v-model="l.add_vat_to_total" :value="true"></v-checkbox>
                            </div>
                          </v-flex>
                          <v-flex xs6 class="text-xs-center" px-2>
                            <div style="font-size:21px;" class="font-weight-bold">Total: {{ getTotal(l, l.key) }}</div>
                            <div style="font-size:21px;" class="font-weight-bold" v-if="l.delivery_fees_converted">Delivery Fees: {{ l.delivery_fees_converted }}</div>
                            <div class="font-weight-bold">Tax: {{ getTotalAfterTax(l, l.key).tax }}</div>
                            <div class="font-weight-bold">Manual Discount: {{ l.manual_discount }} %</div>
                            <div style="font-size:32px;" class="font-weight-bold">
                              <v-icon size="50" v-if="l.manual_discount && l.manual_discount > 50" color="error">warning</v-icon>
                              Total After Tax: {{ getTotalAfterTax(l, l.key).total }}
                            </div>
                          </v-flex>
                        </v-layout>
                        
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="pa-2" v-if="l.ninja">
                      <v-flex v-for="(item, i) in l.order" :key="`order-${i}`" xs12>
                        <v-layout row wrap align-center>
                          <v-flex xs3 px-2>
                            PRODUCT
                            <v-autocomplete
                              label="Product"
                              v-model="l.order[i].product"
                              solo
                              clearable
                              item-value="item_name"
                              item-text="item_name"
                              :filter="filterObject"
                              :items="getItems('product', l)"
                              @change="getSKU(l, i)"
                              append-outer-icon="info"
                              @click:append-outer="()=>{
                                getDialogProduct(l, i);
                                dialogs.info = true;
                              }"
                            >
                              <template
                                  slot="prepend"
                              >
                                <v-tooltip top>
                                  <template slot="activator">
                                    <v-icon on="on" v-if="getProductNote(l, i)" color="error">warning</v-icon>
                                    
                                  </template>
                                  <div v-html="getProductNote(l, i)"></div>
                                </v-tooltip>
                              </template>
                              <template
                                  slot="item"
                                  slot-scope="{ parent, item }"
                              >
                                <v-list-tile-action>
                                  <v-icon color="primary">amp_stories</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title v-html="item.item_name"></v-list-tile-title>
                                  <v-list-tile-sub-title v-html="item.name_ar"></v-list-tile-sub-title>
                                  <v-list-tile-sub-title v-html="item.sku"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-avatar v-if="item.img">
                                  <img :src="item.img">
                                </v-list-tile-avatar>
                              </template>
                            </v-autocomplete>
                            <v-layout row justify-center>
                              <v-dialog v-model="dialogs.info" scrollable max-width="500px">
                                <v-card>
                                  <v-card-title>Product Info: {{ productDialogSKU }}</v-card-title>
                                  <v-divider></v-divider>
                                  <v-card-text class="text-xs-center">
                                    <img :src="productDialogImage" width="50%">
                                    <v-divider></v-divider>
                                    <span v-html="productDialogAr"></span>
                                    <v-divider></v-divider>
                                    <span v-html="productDialogEn"></span>
                                  </v-card-text>
                                  <v-divider></v-divider>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="success darken-1" :disabled="productsending" :loading="productsending" flat @click="sendProductToWA(l)">SEND TO WA</v-btn>
                                    <v-btn color="blue darken-1"  flat @click.native="dialogs.info = false">Close</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-layout>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <v-btn :disabled="l.order[i].quantity < 1" @click="removeQuantityToNinjaItem(l, i)" icon small flat color="primary" dark>
                              <v-icon>remove_circle</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs2 px-2>
                            Quantity
                            
                            <v-text-field
                              label="Quantity"
                              v-model="l.order[i].quantity"
                              solo
                              readonly
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <v-btn @click="addQuantityToNinjaItem(l, i)" icon small flat color="primary" dark>
                              <v-icon>add_circle</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <div>Per Item</div>
                            <div>{{ (parseFloat(l.order[i].total) / parseFloat(l.order[i].quantity)).toFixed(1) }} {{ l.currency_symbol }}</div>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <div>SKU</div>
                            <div>{{ l.order[i].sku }}</div>
                          </v-flex>
                          <v-flex xs2 px-2>
                            <div>Total</div>
                            <div>{{ l.order[i].total }} {{ l.currency_symbol }}</div>
                          </v-flex>
                          <v-flex xs1 px-2>
                            <v-btn @click="removeProductFromOrder(l, i)" icon small flat color="primary" dark>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                              
                    <v-layout row wrap class="pa-2" v-if="l.ninja">
                      <v-flex xs12>
                        <v-btn @click="addProductToOrder(l)" color="primary" dark>Add Product to Ninja order</v-btn>
                      </v-flex>
                      <v-flex xs3>
                        <v-btn @click="checkMinPrice(l)" color="primary" dark>check min total</v-btn>
                      </v-flex>
                      <v-flex xs9>
                        Min Total = {{l.min_total}}
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                          label="Manual Total"
                          solo
                          @keypress="()=>{
                            isNumber($event)
                            checkMinPrice(l)
                          }"
                          v-model.trim="l.manual_total"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                      </v-flex>
                      <v-flex xs4>
                        <v-layout row wrap align-center>
                          <v-flex xs12 class="text-xs-left" style="font-size:20px;">
                            Delivery: {{l.cart_delivery_fees}} {{ l.currency_symbol }}
                          </v-flex>
                          <v-flex xs12 class="text-xs-left" style="font-size:20px;">
                            Tax: {{l.cart_tax}} {{ l.currency_symbol }}
                          </v-flex>
                          <v-flex xs12 class="text-xs-left" style="font-size:22px;">
                            Total: {{l.ninja_total ? l.ninja_total : l.total}}
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap class="pa-2" v-if="l.ninja">
                      <v-flex xs12>
                        <v-checkbox label="Exception" v-model="l.exception" :value="true"></v-checkbox>
                        <v-checkbox label="Up" v-model="l.up" :value="true"></v-checkbox>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn 
                        :loading="loading" 
                        color="primary" 
                        v-if="beta"
                        :disabled="(l.order_status == 'Dispatch' || l.order_status == 'Paid') && userRole != 'admin'"
                        @click="triggerUpdate()">
                      <v-icon left>save</v-icon>
                        OLD Save</v-btn>

                      <v-btn 
                        :loading="loading" 
                        color="primary" 
                        v-if="(l.shipping_status != 'Out for delivery' && l.shipping_status != 'return' && l.shipping_status != 'Paid' && l.shipping_status != 'Delivered' && !l.locked ) || superAdmin"
                        @click="backUpdate()">
                      <v-icon left>save</v-icon>
                        Save</v-btn>

                      
                    </v-card-actions>
                  </v-card>
                  <v-dialog 
                    persistent 
                    v-if="false"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                    v-model="dialogs.map"
                    >
                      <v-card>
                        <v-toolbar flat dense dark color="secondary">
                          <v-toolbar-title class="white--text">{{ l.name }} Address</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                          <v-divider vertical></v-divider>
                            <v-btn dark flat 
                              :loading="loading" 
                              @click="()=>{
                              dialogs.map = false
                              clearAddressCity(l)
                              }"
                            >
                            <v-icon left>close</v-icon>
                            Cancel</v-btn>
                          <v-divider vertical></v-divider>
                            <v-btn dark flat 
                              :loading="loading" 
                              @click="fixAddress(l)"
                            >
                            <v-icon left>save</v-icon>
                            Fix Address</v-btn>
                          <v-divider vertical></v-divider>
                          </v-toolbar-items>
                        </v-toolbar>
                        <v-card-text class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-card color="primary" class="pt-2 pb-1">
                                <v-layout row wrap>
                                  <v-flex xs6 px-2 pb-1>
                                    <span class="white--text">Search</span>
                                    <v-text-field
                                      :class="`search-${l.key}`"
                                      solo
                                      hide-details
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs6 px-2>
                                    <v-textarea
                                      v-model.trim="l.address"
                                      solo
                                      hide-details
                                    ></v-textarea>
                                  </v-flex>
                                  <v-flex xs6 px-2>
                                  </v-flex>
                                  <v-flex xs6 px-2>
                                    <v-text-field
                                      v-model.trim="l.geocode"
                                      readonly
                                      hide-details
                                      solo
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex>
                          </v-layout>
                          <div class="map" :id="`map-${l.key}`" :ref="`map-${l.key}`"></div>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                </v-flex>
              </v-layout> 
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addstatusdialog" v-if="userRole == 'admin' && !embed" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">You want to add a new Order Status?</v-card-title>
            <v-card-text>
              <v-text-field
                label="Status"
                required
                v-model="newStatus"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="addstatusdialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" flat @click="addStatus()">add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addfaileddeliverstatusdialog" v-if="userRole == 'admin' && !embed" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">You want to add a new Failed Delivery After Payment Status?</v-card-title>
            <v-card-text>
              <v-text-field
                label="Status"
                required
                v-model="newFailedStatus"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="addfaileddeliverstatusdialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" flat @click="addFailedStatus()">add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addshippingstatusdialog" v-if="userRole == 'admin' && !embed" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">You want to add a new Shipping Status?</v-card-title>
            <v-card-text>
              <v-text-field
                label="Status"
                required
                v-model="newShippingStatus"
              ></v-text-field>
              <v-select
                label="Transaction"
                required
                :items="['none', 'add', 'subtract']"
                v-model="newShippingStatusTransaction"
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="addshippingstatusdialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" flat @click="addShippingStatus()">add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="addcitydialog" v-if="userRole == 'admin' && !embed" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">You want to add a new city?</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    label="City"
                    required
                    v-model="newCity"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    label="Country"
                    required
                    :items="countriesLoaded"
                    v-model="newCityCountry"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" flat @click="addcitydialog = false">Cancel</v-btn>
              <v-btn color="green darken-1" flat @click="addCityToCountry()">add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-layout>
    <!------EMBED DIALOG >>>
      <v-layout row justify-center v-if="userRole == 'admin' && !embed">
        <v-dialog v-model="dialogs.embed" persistent max-width="1200">
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex v-for="b in visibleLeads" :key="b.key" xs12 ma-1>
                  <v-card :class="`elevation-4`">
                    <v-toolbar flat dense dark color="secondary">
                      <v-checkbox class="smallerScaleCheck" hide-details  v-model="selectedLeads" height="1" :value="b"></v-checkbox>
                      <v-toolbar-title class="white--text">{{ b.name }}
                        <v-chip>{{ b.order_status }}</v-chip>
                        <v-chip v-if="b.paid" label color="success" class="white--text">Paid</v-chip>
                        <v-chip v-if="!b.paid && b.payment_failed" label color="error" class="white--text">Failed</v-chip>
                          <span style="font-size:11px;">| </span>
                          <span
                              style="font-size:11px;"
                              v-clipboard:copy="b.key"
                              v-clipboard:success="clipboardSuccessHandler"
                              v-clipboard:error="clipboardErrorHandler"
                            >{{b.key}}
                          </span>
                          <span style="font-size:14px;"> | </span>
                          <span style="font-size:14px;" v-if="b.order">
                            ${{getBaseTotal(b)}}
                          </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-toolbar-items>
                      <v-divider vertical></v-divider>
                      <v-btn 
                        flat
                        @click="()=>{ dialogs.editing = true; selectForEdit(b)  }"
                        >
                        <v-icon left>loop</v-icon>
                        proccess order
                      </v-btn>
                      <v-divider vertical></v-divider>
                      <v-btn icon @click="goTo(`wa-new-chat/n/${b.wa_number ? b.wa_number : b.phone_number_1}`)">
                        <v-icon>send</v-icon>
                      </v-btn>
                      </v-toolbar-items>
                      <v-avatar
                        size="14px"
                        :color="getStatus(b)"
                      >
                      </v-avatar>
                    </v-toolbar>
                    <v-expansion-panel expand>
                      <v-expansion-panel-content>
                        <div slot="header">Order Details 
                          
                        </div>
                        <v-card>
                          <v-card-text class="py-0">
                            <v-layout row wrap>    
                              <v-flex xs6 md10>
                                <v-layout row wrap>
                                  <v-flex 
                                    v-for="(key, i) in basicFields.filter(f=>{
                                      let n = ['order_status', 'confirm', 'processed']
                                      if (n.indexOf(f) == -1) return f
                                    })" 
                                    :key="i" 
                                    xs6 md2 pa-1>
                                    <v-tooltip top>
                                      <div slot="activator" class="caption grey--text ">{{ key.toUpperCase() | truncate(8,(key.length>8 ? '..': '' ) ) }}</div>
                                      <span>{{ key.toUpperCase() }}</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                      <span slot="activator" v-if="typeof b[key] == 'string'">
                                        {{ b[key] | truncate(8, (b[key] ? b[key].length>8 ? '..': '' : '' )) }}</span>
                                      <span>{{ b[key] }}</span>
                                    </v-tooltip>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-layout row wrap>
                                      <v-flex v-if="b.status_timeline" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getTimlineArray(b.status_timeline)"
                                              :key="event.key"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                      <v-flex v-if="b.update_timeline && superAdmin" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getUpdateTimlineArray(b.update_timeline)"
                                              :key="event.key + event.date"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                      <v-flex v-if="b.shipping_status_timeline" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getShippingTimlineArray(b.shipping_status_timeline)"
                                              :key="event.key"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                      <v-flex v-if="b.shipping_timeline" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getUpdateTimlineArray(b.shipping_timeline)"
                                              :key="event.key"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                      <v-flex v-if="b.delivery_status_timeline && false" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getDeliveryTimlineArray(b.delivery_status_timeline)"
                                              :key="event.key"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                      <v-flex v-if="b.delivery_timeline" xs6 pa-1 my-1>
                                        <v-timeline dense class="elevation-2">
                                          <v-slide-x-reverse-transition
                                            group
                                            hide-on-leave
                                          >
                                            <v-timeline-item
                                              v-for="event in getUpdateTimlineArray(b.delivery_timeline)"
                                              :key="event.key"
                                              small
                                              fill-dot
                                            >
                                              {{ event.key.split('_').join(' ').toUpperCase() }}
                                              <v-chip 
                                                color="primary"
                                                label
                                                small
                                                text-color="white"
                                              >
                                                {{ event.date | formatDate }}
                                              </v-chip>
                                              <v-chip 
                                              color="secondary" 
                                              label
                                              small
                                              text-color="white"
                                              >
                                                {{ event.agent }}
                                              </v-chip>
                                            </v-timeline-item>
                                          </v-slide-x-reverse-transition>
                                        </v-timeline>
                                      </v-flex>
                                    </v-layout> 
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex xs6 md2 pa-1>
                                <v-layout row wrap>
                                  <v-flex xs12 py-1 px-2>
                                    <div class="caption grey--text ">Status</div>
                                    <v-tooltip top>
                                      <span slot="activator">
                                        <v-avatar
                                          size="14px"
                                          :color="getStatus(b)"
                                        >
                                        </v-avatar>
                                      </span>
                                      <span>{{ b.processed ? b.confirm ? 'Order Confirmed' : 'Order Canceled' : 'Not Processed' }}</span>
                                    </v-tooltip>
                                  </v-flex>
                                  <v-flex xs12 v-if="b.order && b.order.length != 0">
                                    <v-tooltip top>
                                      <v-chip slot="activator" color="primary" class="white--text">
                                        Total: {{ getTotal(b) }}
                                      </v-chip>
                                      <span>Total: {{ getTotal(b) }}</span>
                                    </v-tooltip>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>                
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn 
                              v-if="beta"
                              dark
                              color="primary"
                              @click="sendWANotification(b)"
                              >
                              n proccess order
                            </v-btn>
                            <v-btn 
                              dark
                              color="primary"
                              @click="()=>{ dialogs.editing = true; selectForEdit(b)  }"
                              >
                              proccess order
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                  </v-card>
                </v-flex>
              </v-layout>   
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="()=>{dialogs.embed = false;resetEmbed()}">close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    -->
  </div>
</template>
<script>
import {firebase, db, auth, store} from '@/fb';
import MiniStatistic from '@/components/MiniStatistic';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
import Papa from 'papaparse'
import { setTimeout } from 'timers';
// import gmapsInit from '@/gmaps'
const loadedLeadsForBackup = []
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};
import json2csv from 'json2csv'
import countriesJSON from '@/countries-ash.json'
export default {
  components:{ MiniStatistic},
  data() {
    return {
      onlyKitems:false,
      onlySubvendor:false,
      selectedAccountId:false,
      dDate:false,
      fd:false,
      td:false,
      fud:false,
      tud:false,
      fsd:false,
      tsd:false,
      fshid:false,
      tshid:false,
      loading:false,
      exportLoading:false,
      dialogs:{
        delete:false,
        editing:false,
        export:false,
        bulkdelete:false,
        map:false,
        qr:false,
        numbers:false,
        info:false,
      },
      crms:[
        {text:'CFD', value:'cfd'}, 
        {text:'ClickTrade', value:'clicktrade'}, 
        {text:'Umarkets', value:'umarkets'}
      ],
      newWANumberDialog:false,
      orderFields:[],
      selectedCRM:null,
      leads:[],
      visibleLeads:[],
      filteredLeads:[],
      basicFields:[],
      searchCats:[],
      selectedSearchCat:null,
      searchText:'',
      countries:[],
      selectedCountries:null,
      campaigns:[],
      selectedCampaign:null,
      contents:[],
      selectedContent:null,
      referrers:[],
      fDate:null,
      fUpdateDate:null,
      fromDates:[],
      selectedFromDates:null,
      tDate:null,
      tUpdateDate:null,
      toDates:[],
      selectedToDates:null,
      selectedReferrer:null,
      selectedLeads:[],
      selectVs:false,
      selectRs:false,
      isLoading:false,
      selectedReserved:null,
      currentPage: 1,
      pageSize: 8,
      pagesNumber:0,
      width:5,
      onlyNotSent:false,
      alreadySent:false,
      leadPlus:false,
      onlyFTD:false,
      countriesLoaded:[],
      usersLoaded:[],
      productsLoaded:[],
      citiesLoaded:[],
      orderstatusesLoaded:[],
      productsFullLoaded:[],
      countriesFullLoaded:[],
      faileddeliverystatusesLoaded:[],
      campaignsLoaded:[],
      gendersLoaded:[],
      languagesLoaded:[],
      companiesLoaded:[],
      sourcesLoaded:[],
      userselectcreate:null,
      nselect:[],
      sselect:null,
      userselect:null,
      pselect:[],
      addstatusdialog:false,
      addshippingstatusdialog:false,
      newShippingStatus:null,
      addcitydialog:false,
      changestatusdialog:false,
      bulkchangestatusdialog:false,
      newStatus:null,
      newCity:null,
      newCityCountry:null,
      newStatusForAll:null,
      companycodes:[],
      selectedCompanyCodes:null,
      searchPhoneNumber:null,
      dataStatFilterCount:0,
      dataStatFilterTotal:0,
      dataStatFilterFallbackTotal:0,
      dataStatFilterConfirm:0,
      dataStatFilterBasket:0,
      dataStatFilterCancelHuman:0,
      dataStatFilterCancelNoAnswer:0,
      dataStatFilterCancelNonHuman:0,
      dataStatFilterCancelTotal:0,
      DataStatLoading:false,
      loadedDataStat:[],
      fTLDate:null,
      tTLDate:null,
      fSHIDate:null,
      tSHIDate:null,
      selectedFLStatus:null,
      selectedTLStatus:null,
      selectedSHIStatus:null,
      qrCode:null,
      newWANumber:null,
      waLoading:false,
      tokensLoaded:[],
      selectedToken:null,
      productDialogImage:null,
      productDialogAr:null,
      productDialogEn:null,
      productDialogNameAr:null,
      productDialogNameEn:null,
      productDialogSKU:null,
      initialLoadedNumber:8,
      shippingstatusesLoaded:[],
      allLeadsLoaded:[],
      vouchers:[],
      dataStatFilterPaid:0,
      shiselect:[],
      docNumber:null,
      newShippingStatusTransaction:null,
      deliverystatusesLoaded:[],
      deliveryselect:[],
      selecteddelStatus:null,
      fdeld:null,
      fdelDate:null,
      tdeld:null,
      tdelDate:null,
      taxrates:[],
      productsending:false,
      selectedPaidStatus:[],
      tpaidd:null,
      paidd:null,
      tpaidDate:null,
      paidDate:null,
      addfaileddeliverstatusdialog:false,
      newFailedStatus:null,
      minDate:'2018-01-01',
      ninjaCurrencyFactors:{},

    }
  },
  computed:{
  },
  methods: {
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async searchVoucher(phone){
      if(!phone) {
        this.$emit('snackbarNotification', `Phone Number is required`, 'error')
        return
      }
      let vouchers = await db.ref(`vouchers`).orderByChild('phone_number_1').equalTo(phone).once('value').then(x=>x.val())
      for (const key in vouchers) {
				if (vouchers.hasOwnProperty(key)) {
					const v = vouchers[key];
					this.vouchers.push(v)
				}
			}
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    userVoucher(l, v) {
      if(!v.active) {
        this.$emit('snackbarNotification', `Voucher Not Valid`, 'error')
        return
      }
      this.vouchers.splice(this.vouchers.findIndex(x=> x.uid == v.uid), 1)
      this.selectedLeads.filter(x=> x.key == l.key)[0].voucher = v
      // console.log(this.selectedLeads)
    },
    getUpdateTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = event.status
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getShippingTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    getDeliveryTimlineArray(timeline){
      let timelineArr = []
      for (const key in timeline) {
        if (timeline.hasOwnProperty(key)) {
          const event = timeline[key];
          event.key = key
          timelineArr.push(event)
        }
      }
      return timelineArr.sort(function(a,b){
        return new Date(a.date) - new Date(b.date);
      });
    },
    loadingDialog() {
      if(this.loading || this.DataStatLoading){
        return {
          l:true,
          a:this.loading? '...initializing' : '...loading data'
        }
      } else {
        return {
          l:false
        }
      }
       
    },
    // clearAddressCity(l) {
    //   this.selectedLeads.filter(x=> x.key == l.key)[0].city = ``
    //   this.selectedLeads.filter(x=> x.key == l.key)[0].address = ``
    // },
    hasUnicode(str) {
        for (var i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 127) return true;
        }
        return false;
    },
    // fixAddress(l){
    //   if(l.fet_address == l.address) {
    //     this.$emit('snackbarNotification', `Landmark is required`, 'error')
    //   } else if(l.address.includes('Unnamed Road')) {
    //     this.$emit('snackbarNotification', `Road Cannot be: Unnamed Road`, 'error')
    //   } else if(!l.address.includes('STREET')) {
    //     this.$emit('snackbarNotification', `Street is required`, 'error')
    //   } else if(!l.address.includes('CITY')) {
    //     this.$emit('snackbarNotification', `City is required`, 'error')
    //   } else if(!l.address.toLowerCase().includes('district')) {
    //     this.$emit('snackbarNotification', `District is required`, 'error')
    //   } else if(l.order_status == 'Confirmed' && this.hasUnicode(l.address)) {
    //     this.$emit('snackbarNotification', `All characters must be in english`, 'error')
    //   } else {
    //     delete this.selectedLeads.filter(x=> x.key == l.key)[0].fet_address
    //     if(l.fet_address) {
    //       delete l.fet_address
    //     }
    //     this.dialogs.map = false
    //   }
    // },
    // getAddress(geocoder, marker, infowindow, map, lkey) {
    //   if (confirm('Sure you want to pick address?')) {
    //     var x = marker.getPosition()
    //     var newPosition = {
    //         lat: x.lat(),
    //         lng: x.lng()
    //     };
    //     console.log(newPosition)
    //     var latlng = {
    //         lat: parseFloat(newPosition.lat),
    //         lng: parseFloat(newPosition.lng)
    //     };
    //     geocoder.geocode({
    //       'location': latlng
    //     }, (results, status) => {
    //         if (status === 'OK') {
    //             if (results[0]) {
    //                 map.setZoom(16);
    //                 marker.setOptions({
    //                     position: latlng
    //                 })
    //                 infowindow.setContent(results[0].formatted_address);
    //                 console.log(results[0]);
    //                 //let gg = results[0].address_components.map(x => x.long_name)
    //                 function replaceKeys(key){
    //                   switch (key) {
    //                     case 'ROUTE':
    //                       return 'STREET'
    //                       break;
    //                     case 'LOCALITY':
    //                       return 'CITY'
    //                       break;
    //                     case 'POLITICAL':
    //                       return 'DISTRICT'
    //                       break;
    //                     default:
    //                       return key
    //                       break;
    //                   }
    //                 }
    //                 let gg = results[0].address_components.filter(x=> {
    //                   let nok = ['route', 'locality', 'political']
    //                   if(nok.indexOf(x.types[0]) != -1) {
    //                     return x
    //                   }
    //                 })
    //                 .map(x => `${replaceKeys(x.types[0].toUpperCase())}: ${x.long_name}`)
    //                 let aa = gg.join(' | ')
    //                 let pp = results[0].plus_code ? results[0].plus_code.global_code : 'No Code'
    //                 let ll = results[0].plus_code ? results[0].plus_code.compound_code : 'No Code'
    //                 console.log(this.selectedLeads.filter(x=> x.key == lkey)[0])
    //                 this.selectedLeads.filter(x=> x.key == lkey)[0].fet_address = `${aa}\n`
    //                 this.selectedLeads.filter(x=> x.key == lkey)[0].address = `${aa}\n`
    //                 this.selectedLeads.filter(x=> x.key == lkey)[0].geocode = `${latlng.lat}, ${latlng.lng}`
    //                 infowindow.open(map, marker);
    //             } else {
    //                 window.alert('No results found');
    //             }
    //         } else {
    //             window.alert('Geocoder failed due to: ' + status);
    //         }
    //     });
    //   }
      
    // },
    // async startMap(lkey, country) {
    //   try {
		// 		const google = await gmapsInit();
		// 		var initLatLng = {
		// 			lat: 31.928543,
		// 			lng: 35.929693
		// 		}
		// 		const geocoder = new google.maps.Geocoder();
		// 		var infowindow = new google.maps.InfoWindow;
		// 		const map = new google.maps.Map(document.getElementById('map-'+lkey), {
		// 			center: initLatLng,
		// 			zoom: 12
		// 		});
				

		// 		var marker = new google.maps.Marker({
		// 				position: initLatLng,
		// 				map: map
		// 		})
		// 		marker.setOptions({
		// 			draggable: true,
		// 			animation: 'DROP'
    //     })
    //     let co = this.countriesFullLoaded.filter(x=> x.name == country || x.cioc == country)[0]
		// 		var options = {
		// 			//types: ['geocode'],
		// 			fields: ['geometry'],
		// 			componentRestrictions: {
		// 				country: co.alpha2Code.toLowerCase()
		// 			}
		// 		};
		// 		console.log(marker.getPosition())
		// 		var autocompvare = new google.maps.places.Autocomplete(document.querySelector('.search-'+lkey+' input'), options);
		// 		// var autocompvare = new google.maps.places.SearchBox(document.querySelector('input'), options);
		// 		google.maps.event.addListener(marker, 'dragend', () => {

    //         console.log(marker)
    //         this.getAddress(geocoder, marker, infowindow, map, lkey)
						
		// 		})
		// 		google.maps.event.addListener(autocompvare, 'place_changed', function (data) {
		// 			//FIRE SEARCH
		// 			console.log(autocompvare.getPlace())
		// 			var x = autocompvare.getPlace()
		// 			console.log('------------------------------------');
		// 			console.log(x);
		// 			console.log('------------------------------------');
		// 			console.log(x.geometry.location.lat());
		// 			console.log(x.geometry.location.lng());
		// 			var newPosition = {
		// 					lat: x.geometry.location.lat(),
		// 					lng: x.geometry.location.lng()
		// 			}
		// 			map.setCenter(new google.maps.LatLng(newPosition.lat, newPosition.lng));
		// 			map.setZoom(16)
		// 			marker.setOptions({
		// 					position: newPosition
		// 			})
		// 			infowindow.setContent('Drag to exact location');
		// 		});

		// 	} catch (error) {
		// 		console.error(error);
		// 	}
    // },
    prepFilterLink(){
      let exportURL = ``
      
      if(this.selectedCompanyCodes) exportURL += `&company=${this.selectedCompanyCodes.join('|')}`
      if(this.userselect) exportURL += `&agent=${this.userselect.join('|')}`
      if(this.selectedCountries) exportURL += `&country=${this.selectedCountries.join('|')}`
      if(this.selectedCampaign) exportURL += `&campaign=${this.selectedCampaign.join('|')}`
      if(this.selectedReferrer) exportURL += `&referrer=${this.selectedReferrer.join('|')}`
      if(this.fDate && this.tDate) exportURL += `&fDate=${this.fDate}&tDate=${this.tDate}`
      if(this.fUpdateDate && this.tUpdateDate) exportURL += `&fUpdateDate=${this.fUpdateDate}&tUpdateDate=${this.tUpdateDate}`
      if(this.searchText && this.searchText != '' && this.searchText != null && this.selectedSearchCat) 
        exportURL += `&search=${this.searchText}&searchcat=${this.selectedSearchCat}`
      if(this.nselect.length != 0) exportURL += `&status=${this.nselect.join('|')}`
      if(this.shiselect.length != 0) exportURL += `&shistatus=${this.shiselect.join('|')}`
      if(this.deliveryselect.length != 0) exportURL += `&delstatus=${this.deliveryselect.join('|')}`
      if(this.newStatusForAll) exportURL += `&order_status=${this.newStatusForAll}`
      if(this.pselect.length != 0) exportURL += `&products=${this.pselect.join('|')}`
      if(this.fTLDate && this.tTLDate && this.selectedTLStatus) exportURL += `&fTLDate=${this.fTLDate}&tTLDate=${this.tTLDate}&TLStatus=${this.selectedTLStatus}`
      if(this.fSHIDate && this.tSHIDate && this.selectedSHIStatus) exportURL += `&fSHIDate=${this.fSHIDate}&tSHIDate=${this.tSHIDate}&SHIStatus=${this.selectedSHIStatus}`
      if(this.fdelDate && this.tdelDate && this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}&delStatus=${this.selecteddelStatus}`
      if(!this.fdelDate && !this.tdelDate && this.selecteddelStatus) exportURL += `&delStatus=${this.selecteddelStatus}`
      if(this.fdelDate && this.tdelDate && !this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}`
      if(this.selectedToken) exportURL += `&token=${this.selectedToken.join('|')}`
      if(this.$props.userData.uid) exportURL += `&caller=${this.$props.userData.uid}`
      if(this.userselectcreate) exportURL += `&creator=${this.userselectcreate}`
      if(this.docNumber) exportURL += `&docNumber=${this.docNumber}`
      if(this.onlyKitems) exportURL += `&vproducts=${this.onlyKitems}`
      if(this.onlySubvendor) exportURL += `&onlysuborders=${this.onlySubvendor}`
      
      if(this.paidDate && this.tpaidDate && this.selectedPaidStatus.length) exportURL += `&paidDate=${this.paidDate}&tpaidDate=${this.tpaidDate}&selectedPaidStatus=${this.selectedPaidStatus.join('|')}`
      if(this.selectedReserved) exportURL += `&reserved=${this.selectedReserved}`
      // console.log(exportURL)
      return exportURL
    },
    filterLeads() {
      this.loading = true
      this.filteredLeads = this.allLeadsLoaded
      .filter(lead=>{ // paid filter
        if(!this.selectedPaidStatus.length) {
          return lead
        } else {
          if(!this.paidDate && !this.tpaidDate) {
            if (this.selectedPaidStatus.includes('PAID') && lead.paid) {
              return lead
            } 
            if (this.selectedPaidStatus.includes('FAILED') && lead.payment_failed) {
              return lead
            }
            if (this.selectedPaidStatus.includes('TRIED') && lead.payment_visit_date) {
              return lead
            }
          } else {
            if (this.selectedPaidStatus.includes('PAID') && lead.paid && this.paidDate && this.tpaidDate) {
              let t = new Date(lead.payment_date).getTime()
              let x = new Date(this.paidDate).getTime() - 4 * 1000*60*60
              let y = new Date(this.tpaidDate).getTime() + 20 * 1000*60*60 - 1000
              if ( t > x && t < y ) return lead
            }
            if (this.selectedPaidStatus.includes('FAILED') && lead.payment_failed && this.paidDate && this.tpaidDate) {
              let t = new Date(lead.payment_failed_date).getTime()
              let x = new Date(this.paidDate).getTime() - 4 * 1000*60*60
              let y = new Date(this.tpaidDate).getTime() + 20 * 1000*60*60 - 1000
              if ( t > x && t < y ) return lead
            }
            if (this.selectedPaidStatus.includes('TRIED') && lead.payment_failed && this.paidDate && this.tpaidDate) {
              let t = new Date(lead.payment_visit_date).getTime()
              let x = new Date(this.paidDate).getTime() - 4 * 1000*60*60
              let y = new Date(this.tpaidDate).getTime() + 20 * 1000*60*60 - 1000
              if ( t > x && t < y ) return lead
            }
          }
        }
      })
      .filter(lead=>{ // country filter
        if(!this.selectedCountries || this.selectedCountries.length == 0) {
          return lead
        } else {
          if (this.selectedCountries.indexOf('No Country') != -1 && (lead.country == null || lead.country == '')) {
            return lead
          } else {
            if(lead.country && this.selectedCountries.map(x=>x.toUpperCase()).indexOf(lead.country.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // campaign filter
        if(!this.selectedCampaign || this.selectedCampaign.length == 0) {
          return lead
        } else {
          if (this.selectedCampaign.indexOf('No Campaign') != -1 && (lead.campaign_code == null || lead.campaign_code =='')) {
            return lead
          } else {
            if(lead.campaign_code && this.selectedCampaign.map(x=>x.toUpperCase()).indexOf(lead.campaign_code.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // source
        if(!this.selectedReferrer || this.selectedReferrer.length == 0) {
          return lead
        } else {
          if (this.selectedReferrer.indexOf('No Source') != -1 && ( lead.order_source == null || lead.order_source == '')) {
            return lead
          } else {
            if(lead.order_source && this.selectedReferrer.map(x=>x.toUpperCase()).indexOf(lead.order_source.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // document number
        if(!this.docNumber) {
          return lead
        } else {
          if (this.docNumber == 'No Document Number' && !lead.document_number ) {
            return lead
          } else if (this.docNumber == 'Document Number' && lead.document_number ) {
            return lead
          }
        }
      })
      .filter(lead=>{ // import date
        if(!this.fDate) return lead
        if(!this.tDate) return lead
        let t = new Date(lead.import_date).getTime()
        let x = new Date(this.fDate).getTime()
        let y = new Date(this.tDate).getTime()
        if (t >= x && t <= y) return lead
      })
      .filter(lead=>{ // status date
        if(!this.fTLDate) return lead
        if(!this.tTLDate) return lead
        if(!this.selectedTLStatus) return lead
        if(lead.status_timeline) {
          let status = this.selectedTLStatus.split(' ').join('_').toLowerCase()
          if(lead.status_timeline[status] && lead.status_timeline[status].date){
            let t = new Date(lead.status_timeline[status].date).getTime()
            let x = new Date(this.fTLDate).getTime()
            let y = new Date(this.tTLDate).getTime()
            if (t >= x && t <= y) return lead
          }
        }
      })
      .filter(lead=>{ // shipping status date
        if(!this.fSHIDate) return lead
        if(!this.tSHIDate) return lead
        if(!this.selectedSHIStatus) return lead
        if(lead.shipping_status_timeline) {
          let status = this.selectedSHIStatus.split(' ').join('_').toLowerCase()
          if(lead.shipping_status_timeline && lead.shipping_status_timeline[status] && lead.shipping_status_timeline[status].date){
            let t = new Date(lead.shipping_status_timeline[status].date).getTime()
            let x = new Date(this.fSHIDate).getTime()
            let y = new Date(this.tSHIDate).getTime()
            if (t >= x && t <= y) return lead
          }
        }
      })
      .filter(lead=>{ // delivery status date
        if(!this.fdelDate) return lead
        if(!this.tdelDate) return lead
        if(!this.selecteddelStatus) return lead
        if(lead.delivery_status_timeline) {
          let status = this.selecteddelStatus.split(' ').join('_').toLowerCase()
          if(lead.delivery_status_timeline && lead.delivery_status_timeline[status] && lead.delivery_status_timeline[status].date){
            let t = new Date(lead.delivery_status_timeline[status].date).getTime()
            let x = new Date(this.fdelDate).getTime()
            let y = new Date(this.tdelDate).getTime()
            if ( t > x && t < y ) return lead
          }
        }
      })
      .filter(lead=>{ // update date
        if(!this.fUpdateDate) return lead
        if(!this.tUpdateDate) return lead
        if(this.fUpdateDate && this.tUpdateDate)
        for (const status in lead.status_timeline) {
					if (lead.status_timeline.hasOwnProperty(status)) {
						const timeline = lead.status_timeline[status];
            let t = new Date(timeline.date).getTime()
            let x = new Date(this.fUpdateDate).getTime()
            let y = new Date(this.tUpdateDate).getTime()
            if (t >= x && t <= y) return lead
					}
				}
      })
      .filter(lead=>{ // search
        if(!this.searchText || this.searchText == '' || this.searchText == null) return lead
        if(!this.selectedSearchCat) return lead
        let search = this.searchText.toLowerCase()
        let key = this.selectedSearchCat.toLowerCase()
        if(lead[key] && lead[key].toLowerCase().includes(search)) return lead
      })
      .filter(lead=>{ //status
        if(this.nselect.length == 0) {
          return lead
        } else {
          if (this.nselect.indexOf('No Status') != -1 && (lead.order_status == null || lead.order_status == '')) {
            return lead
          } else {
            if(lead.order_status && this.nselect.map(x=>x.toUpperCase()).indexOf(lead.order_status.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // shipping status
        if(this.shiselect.length == 0) {
          return lead
        } else {
          if (this.shiselect.indexOf('No Status') != -1 && (lead.shipping_status == null || lead.shipping_status == '')) {
            return lead
          } else {
            if(lead.shipping_status && this.shiselect.map(x=>x.toUpperCase()).indexOf(lead.shipping_status.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // delivery status
        if(this.deliveryselect.length == 0) {
          return lead
        } else {
          if (this.deliveryselect.indexOf('No Status') != -1 && (lead.delivery_status == null || lead.delivery_status == '')) {
            return lead
          } else {
            if(lead.delivery_status && this.deliveryselect.map(x=>x.toUpperCase()).indexOf(lead.delivery_status.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // product
        if(this.pselect.length == 0) return lead
        if (this.pselect && lead.order && lead.order.length != 0) {
          for (let i = 0; i < lead.order.length; i++) {
            const item = lead.order[i];
            // console.log(item.product)
            if(this.pselect.indexOf(item.product) != -1) {
              // console.log('t')
              return lead; 
            }
          }
        }
      })
      .filter(lead=>{ // agent 
        if(!this.userselect) return lead
        if(lead.agent_name && this.userselect && this.userselect.map(x=>x.toUpperCase()).indexOf(lead.agent_name.toUpperCase()) != -1 ) return lead
      })
      .filter(lead=>{ // creator agent 
        if(!this.userselectcreate) return lead
        if(lead.creator_agent && this.userselectcreate && this.userselectcreate.map(x=>x.toUpperCase()).indexOf(lead.creator_agent.toUpperCase()) != -1 ) return lead
      })
      .filter(lead=>{ // company codes
        if(!this.selectedCompanyCodes || this.selectedCompanyCodes.length == 0) {
          return lead
        } else {
          if (this.selectedCompanyCodes.indexOf('No Code') != -1 && (lead.company_code == null || lead.company_code == '')) {
            return lead
          } else {
            if(lead.company_code && this.selectedCompanyCodes.map(x=>x.toUpperCase()).indexOf(lead.company_code.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .filter(lead=>{ // token
				if(!this.selectedToken || this.selectedToken.length == 0) return lead
        if(lead.token 
          && this.selectedToken
					&& this.selectedToken.indexOf(lead.token) != -1
        ) return lead
      })
      .filter(lead=>{ // reserved
        if(!this.selectedReserved) {
           return lead
        } else if(this.selectedReserved == 'True' && lead.reserved) {
          return lead
        } else if (this.selectedReserved == 'False' && !lead.reserved) {
          return lead
        }
      })
      .filter(lead=>{ // account_id
        if(!this.selectedAccountId) {
          return lead
        } else if(this.selectedAccountId && lead.ninja && lead.account_id == this.selectedAccountId) {
          return lead
        } 
      })
      
      // this.exportData(this.filteredLeads, 'filtered_leads')
      this.getFilterTotals()
      this.filteredLeads = this.filteredLeads.slice(0, this.initialLoadedNumber)
      this.getPagesNumber()
      this.currentPage = 1
      this.updateVisible()
    },
    getFilterTotals(){
      // console.log('getting totals')
      let confirmed = [ 'Confirmed', 'Dispatch', 'NEW Confirm', 'Paid', 'Cancel Combine', 'pending payment'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
	    let noSource = ['logstic', 'telemarketing', 'telemarkitig', 'c.care']
      let allLeads = this.filteredLeads.filter(x=> x.order_source && !noSource.includes(x.order_source.toLowerCase().trim()) && x.campaign_code && !x.campaign_code.toLowerCase().includes('up') )
      let grandTotal = 0
      let fTotal = 0
      let counter = 0
      // console.log(allLeads.filter(l=>confirmed.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))))
      for (let i = 0; i < allLeads.filter(l=>confirmed.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))).length; i++) {
        const l = allLeads[i];
        if(l.invoice_total) {
          // console.log(l.invoice_total)
          grandTotal += parseFloat(l.invoice_total)
          // console.log(grandTotal)
          counter++
        }
      }
      
      let grandCount = 0
      let confirmCount = 0
      let cancelCount = 0
      let humanCount = 0
      let nonhumanCount = 0
      let noAnswerCount = 0
      let paidcount = 0
	    
	    let nonHuman = ['Cancel - Duplicate', 'cancel NSA', 'Cancel Whatsapp', 'Cancel reject previous order'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
	    let Human = [ 'Cancel - CIM', 'Cancel - Price', "Cancel - Didn't need the order", 'Cancel - Others', 'Cancel ID', 'Cancel wrong number', 'cancel wrong person', "Cancel - Didn't Request", 'Cancel Delivery Fees', 'Cancel - Corona (COVID-19)', "Cancel don't have Card", 'Payment Order'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
	    let noAnswer = [ '1st NA', '2nd NA', '3rd NA', 'Cancel - No Answer', 'call back', 'NEW', 'NEED CHECK', 'Call back After 11:00AM'].map(x=>x.trim().toLowerCase().replace(/ /g, '_'))
      for (const key in allLeads) {
        if (allLeads.hasOwnProperty(key)) {
          const l = allLeads[key];
          grandCount++
          if(l.order_status){
            if(confirmed.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))) {
              confirmCount++
            }
            if(nonHuman.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))) {
              cancelCount++
              nonhumanCount++
            }
            if(Human.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))) {
              cancelCount++
              humanCount++
            }
            if(noAnswer.includes(l.order_status.trim().toLowerCase().replace(/ /g, '_'))) {
              cancelCount++
              noAnswerCount++
            }
          }
          if( l.phoneOneValidateOnSave ){
            paidcount++
          }
        }
      }
      this.dataStatFilterPaid = paidcount
      this.dataStatFilterCount = allLeads.length
      this.dataStatFilterTotal = `${parseInt(grandTotal)}`
      this.dataStatFilterFallbackTotal = parseInt(fTotal)
      this.dataStatFilterBasket = (this.dataStatFilterTotal / counter).toFixed(2)
      this.dataStatFilterConfirm = `${(confirmCount/grandCount*100).toFixed(2)}`
      this.dataStatFilterCancelHuman = `${(humanCount/grandCount*100).toFixed(2)}`
      this.dataStatFilterCancelNoAnswer = `${(noAnswerCount/grandCount*100).toFixed(2)}`
      this.dataStatFilterCancelNonHuman = `${(nonhumanCount/grandCount*100).toFixed(2)}`
      this.dataStatFilterCancelTotal = `${(cancelCount/grandCount*100).toFixed(2)}`
    },
    deleteAll(){
      this.loading = true
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/deleteByFilter/?=`
      exportURL += this.prepFilterLink()
      axios.get(exportURL)
      .then(resp=>{
        if (resp.data.status) {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `${resp.data.count} Leads Deleted Successfully`, 'success')
          this.filterLeads()
        } else {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `Leads Status Delete Failed`, 'error')
        }
      })
    },
    showLeads(leads){
      this.leads = []
      this.visibleLeads = []
      this.filteredLeads = []
      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          const lead = leads[key];
          let nKesys = ['order_status', 'order', 'note', 'update_date', 'address']
          nKesys.forEach(key=>{
            if ( typeof lead[key] === 'undefined' && key != 'order') 
            lead[key] = null
            if(typeof lead[key] === 'undefined' && key == 'order')
            lead[key] = []
          })
          let index = this.leads.findIndex(x => x.key === lead.key)
          if(index != -1) this.leads.splice(index, 1, lead); 
          if(index === -1) this.leads.push(lead)
          let bindex = loadedLeadsForBackup.findIndex(x => x.key === lead.key)
          if(bindex != -1) loadedLeadsForBackup.splice(bindex, 1, Object.assign({}, lead)); 
          if(bindex === -1) loadedLeadsForBackup.push(Object.assign({}, lead))
        }
      }
      this.visibleLeads = this.leads
      this.getPagesNumber()
      this.updateVisible()
      this.loading = false
    },
    getDataStats(){
      this.loading = true
      this.leads = []
      this.visibleLeads = []
      this.filteredLeads = []
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/dataApi/?=`
      exportURL += this.prepFilterLink()
      return axios.get(exportURL)
      .then(resp=>{
        if (resp.data.status) {
          // console.log(resp.data)
          if(resp.data.blocked){
            this.$emit('snackbarNotification', `You Are Blocked, please contact Moataz`, 'error')
            this.loading = false
            this.DataStatLoading  = false
            return
          }
          resp.data.leads.reverse()
          this.showLeads(resp.data.leads.slice(0, this.initialLoadedNumber))
          this.allLeadsLoaded = resp.data.leads
          this.dataStatFilterPaid = resp.data.paid
          this.dataStatFilterCount = resp.data.count
          this.dataStatFilterTotal = resp.data.total
          this.dataStatFilterBasket = resp.data.basket
          this.dataStatFilterConfirm = resp.data.confirm
          this.dataStatFilterCancelHuman = parseFloat(resp.data.cancelHuman)
          this.dataStatFilterCancelNoAnswer = parseFloat(resp.data.cancelNoAnswer)
          this.dataStatFilterCancelNonHuman = parseFloat(resp.data.cancelNonHuman)
          this.dataStatFilterCancelTotal = parseFloat(resp.data.cancelTotal)
          this.countries = resp.data.countries
          this.campaigns = resp.data.campaigns.map(x=> x.toUpperCase())
          this.contents = resp.data.contents
          this.referrers = resp.data.referrers
          this.companycodes = resp.data.companycodes.map(x=> x.toUpperCase())
          this.searchCats = resp.data.searchCats
          this.tokensLoaded = resp.data.tokens
          this.DataStatLoading  = false
          this.loading = false
          this.$emit('snackbarNotification', `${resp.data.count} Leads Queried Successfully`, 'success')
        } else {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `Leads Query Failed`, 'error')
        }
      })
    },
    getDataStatsNew(){
      this.loading = true
      this.leads = []
      this.visibleLeads = []
      this.filteredLeads = []
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/dataApi/?fire=true`
      exportURL += this.prepFilterLink()
      return axios.get(exportURL)
      .then(resp=>{
        if (resp.data.status) {
          // console.log(resp.data)
          if(resp.data.blocked){
            this.$emit('snackbarNotification', `You Are Blocked, please contact Moataz`, 'error')
            this.loading = false
            this.DataStatLoading  = false
            return
          }
          resp.data.leads.reverse()
          this.showLeads(resp.data.leads.slice(0, this.initialLoadedNumber))
          this.allLeadsLoaded = resp.data.leads
          this.dataStatFilterCount = resp.data.count
          this.dataStatFilterTotal = resp.data.total
          this.dataStatFilterFallbackTotal = resp.data.ftotal
          this.dataStatFilterBasket = (resp.data.total / resp.data.count).toFixed(2)
          this.dataStatFilterConfirm = resp.data.confirm
          this.countries = resp.data.countries
          this.campaigns = resp.data.campaigns.map(x=> x.toUpperCase())
          this.contents = resp.data.contents
          this.referrers = resp.data.referrers
          this.companycodes = resp.data.companycodes.map(x=> x.toUpperCase())
          this.searchCats = resp.data.searchCats
          this.tokensLoaded = resp.data.tokens
          this.DataStatLoading  = false
          this.loading = false
          this.$emit('snackbarNotification', `${resp.data.count} Leads Queried Successfully`, 'success')
        } else {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `Leads Query Failed`, 'error')
        }
      })
    },
    superbulkStatusUpdateThenExport(){
      this.superbulkStatusUpdate()
      .then(x=>{
        this.exportAllLeads()
      })
    },
    superbulkStatusUpdateOldData(){
      this.loading = true
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/statusChangeOldData/?=`
      exportURL += this.prepFilterLink()
      exportURL += `&user=${this.$props.userName}`
      return axios.get(exportURL)
      .then(resp=>{
        if (resp.data.status) {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `${resp.data.count} Leads Status Updated`, 'success')
          this.filterLeads()
        } else {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `Leads Status Updated Failed`, 'error')
        }
        return resp
      })
    },
    superbulkStatusUpdate(){
      this.loading = true
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/statusChange/?=`
      exportURL += this.prepFilterLink()
      exportURL += `&user=${this.$props.userName}`
      return axios.get(exportURL)
      .then(resp=>{
        if (resp.data.status) {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `${resp.data.count} Leads Status Updated`, 'success')
          this.filterLeads()
        } else {
          this.bulkchangestatusdialog = false
          this.loading = false
          this.$emit('snackbarNotification', `Leads Status Updated Failed`, 'error')
        }
        return resp
      })
    },
    superbulkStatusUpdateDate(){
      this.exportLoading = true
      let cStart = this.fDate;
      let cEnd = this.tDate;
      let startDate = new Date(cStart)
      let endDate = new Date(cEnd)
      let i = 0;
      let exportLeads = [];
      (async x=>{
        //console.log((endDate - startDate) / (1000 * 3600 * 24))
        var loopDate = new Date(startDate);
        while (loopDate <= endDate) {
          let year = loopDate.getFullYear()
          let month = ((loopDate.getMonth() + 1) < 10) ? "0" + (loopDate.getMonth() + 1) : (loopDate.getMonth() + 1)
          let day = (loopDate.getDate() < 10) ? "0" + loopDate.getDate() : loopDate.getDate()
          let dayName = loopDate.getDay()
          let weekDayes = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          let nDates = weekDayes[dayName] + ' - ' + day + '/' + month + '/' + year
          let sendFDate = new Date(new Date(cStart).getTime() + 1 * 10 * 60 * 1000 * (i)).toISOString()//.split('T')[0]
          
          let tDat = new Date(cStart).getTime() + 1 * 10 * 60 * 1000 * (i + 1)
          let sendTDate = new Date(tDat>endDate? endDate: tDat).toISOString()//.split('T')[0]
          console.log('from', sendFDate)
          console.log(i)
          console.log('to', sendTDate)
          // console.log(i)
          // if(i>8){
          //   return true
          // }
          let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/statusbydate/changeStatusByDate/?=`
          exportURL += this.prepPartialFilterLink()
          exportURL += `&fDate=${sendFDate}&tDate=${sendTDate}`
          exportURL += `&user=${this.$props.userName}`
          exportURL += `&new_order_status=${this.newStatusForAll}`
          // console.log(exportURL)
          // await this.sleep(5000)
          let a = await axios.get(exportURL).then(x=>x.data)
          // exportLeads = [...exportLeads, ...a]
          i++
          // console.log(i)
          var newDate = loopDate.setDate(loopDate.getDate() + i*1 - 1);
          loopDate = new Date(new Date(sendTDate).getTime() + 1*60*60*1000);
        }
        console.log('exportLeads', exportLeads)
        this.exportLoading = false
        this.exportData(exportLeads)
      })()
    },
    exportAllLeads(){
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/csvExport/?=`
      exportURL += this.prepFilterLink()
      window.open(exportURL)
    },
    exportAllOldLeads(){
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/csvExportOldData/?=`
      exportURL += this.prepFilterLink()
      window.open(exportURL)
    },
    exportAlleadsCourior(){
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/main/csvItemExport/?=`
      exportURL += this.prepFilterLink()
      window.open(exportURL)
    },
    exportAlleadsDate(){
      let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/mainCSV/csvItemExportByDate/?=`
      exportURL += this.prepFilterLink()
      window.open(exportURL)
    },
    prepPartialFilterLink(){
      let exportURL = ``
      if(this.selectedCompanyCodes) exportURL += `&company=${this.selectedCompanyCodes.join('|')}`
      if(this.userselect) exportURL += `&agent=${this.userselect.join('|')}`
      if(this.selectedCountries) exportURL += `&country=${this.selectedCountries.join('|')}`
      if(this.selectedCampaign) exportURL += `&campaign=${this.selectedCampaign.join('|')}`
      if(this.selectedReferrer) exportURL += `&referrer=${this.selectedReferrer.join('|')}`
      if(this.selectedAccountId) exportURL += `&account_id=${this.selectedAccountId}`
      
      // if(this.fDate && this.tDate) exportURL += `&fDate=${this.fDate}&tDate=${this.tDate}`
      if(this.fUpdateDate && this.tUpdateDate) exportURL += `&fUpdateDate=${this.fUpdateDate}&tUpdateDate=${this.tUpdateDate}`
      if(this.searchText && this.searchText != '' && this.searchText != null && this.selectedSearchCat) 
      exportURL += `&search=${this.searchText}&searchcat=${this.selectedSearchCat}`
      if(this.nselect.length != 0) exportURL += `&status=${this.nselect.join('|')}`
      if(this.shiselect.length != 0) exportURL += `&shistatus=${this.shiselect.join('|')}`
      if(this.deliveryselect.length != 0) exportURL += `&delstatus=${this.deliveryselect.join('|')}`
      if(this.newStatusForAll) exportURL += `&order_status=${this.newStatusForAll}`
      if(this.pselect.length != 0) exportURL += `&products=${this.pselect.join('|')}`
      if(this.fTLDate && this.tTLDate && this.selectedTLStatus) exportURL += `&fTLDate=${this.fTLDate}&tTLDate=${this.tTLDate}&TLStatus=${this.selectedTLStatus}`
      if(this.fSHIDate && this.tSHIDate && this.selectedSHIStatus) exportURL += `&fSHIDate=${this.fSHIDate}&tSHIDate=${this.tSHIDate}&SHIStatus=${this.selectedSHIStatus}`
      if(this.fdelDate && this.tdelDate && this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}&delStatus=${this.selecteddelStatus}`
      if(!this.fdelDate && !this.tdelDate && this.selecteddelStatus) exportURL += `&delStatus=${this.selecteddelStatus}`
      if(this.fdelDate && this.tdelDate && !this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}`
      if(this.selectedToken) exportURL += `&token=${this.selectedToken.join('|')}`
      if(this.$props.userData.uid) exportURL += `&caller=${this.$props.userData.uid}`
      if(this.userselectcreate) exportURL += `&creator=${this.userselectcreate}`
      if(this.docNumber) exportURL += `&docNumber=${this.docNumber}`
      if(this.paidDate && this.tpaidDate && this.selectedPaidStatus.length) exportURL += `&paidDate=${this.paidDate}&tpaidDate=${this.tpaidDate}&selectedPaidStatus=${this.selectedPaidStatus.join('|')}`
      if(this.selectedReserved) exportURL += `&reserved=${this.selectedReserved}`
      if (this.onlyKitems) exportURL += `&vproducts=${this.onlyKitems}`
      if (this.onlySubvendor) exportURL += `&onlysuborders=${this.onlySubvendor}`
      return exportURL
    },
    exportAlleadsDatePartialDate(row){
      this.exportLoading = true
      let cStart =this.fDate;
      let cEnd = this.tDate;
      let startDate = new Date(cStart)
      let endDate = new Date(cEnd)
      let i = 0;
      let exportLeads = [];
      (async x=>{
        //console.log((endDate - startDate) / (1000 * 3600 * 24))
        var loopDate = new Date(startDate);
        while (loopDate <= endDate) {
          let year = loopDate.getFullYear()
          let month = ((loopDate.getMonth() + 1) < 10) ? "0" + (loopDate.getMonth() + 1) : (loopDate.getMonth() + 1)
          let day = (loopDate.getDate() < 10) ? "0" + loopDate.getDate() : loopDate.getDate()
          let dayName = loopDate.getDay()
          let weekDayes = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          let nDates = weekDayes[dayName] + ' - ' + day + '/' + month + '/' + year
          let sendFDate = new Date(new Date(cStart).getTime() + 24 * 60 * 60 * 1000 * (i*3+(i*1))).toISOString().split('T')[0]
          let tDat = new Date(cStart).getTime() + 24 * 60 * 60 * 1000 * (i*3+4+(i*1))
          let sendTDate = new Date(tDat>endDate? endDate: tDat).toISOString().split('T')[0]
          // console.log(sendFDate)
          // console.log(sendTDate)
          // console.log(i)
          let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/mainCSV/csvItemExportByDateLoop/?=`
          exportURL += this.prepPartialFilterLink()
          exportURL += `&fDate=${sendFDate}&tDate=${sendTDate}`
          if(row){
            exportURL += `&row=true`
          }
          // console.log(exportURL)
          await this.sleep(5000)
          let a = await axios.get(exportURL).then(x=>x.data)
          exportLeads = [...exportLeads, ...a]
          i++
          // // console.log(i)
          var newDate = loopDate.setDate(loopDate.getDate() + i*3 - 4);
          loopDate = new Date(new Date(sendTDate).getTime() + 24*60*60*1000);
        }
        console.log('exportLeads', exportLeads)
        this.exportLoading = false
        this.exportData(exportLeads)
      })()
    },
    prepPartialStatusFilterLink(){
      let exportURL = ``
      if(this.selectedCompanyCodes) exportURL += `&company=${this.selectedCompanyCodes.join('|')}`
      if(this.userselect) exportURL += `&agent=${this.userselect.join('|')}`
      if(this.selectedCountries) exportURL += `&country=${this.selectedCountries.join('|')}`
      if(this.selectedCampaign) exportURL += `&campaign=${this.selectedCampaign.join('|')}`
      if(this.selectedReferrer) exportURL += `&referrer=${this.selectedReferrer.join('|')}`
      if(this.selectedAccountId) exportURL += `&account_id=${this.selectedAccountId}`
      
      // if(this.fDate && this.tDate) exportURL += `&fDate=${this.fDate}&tDate=${this.tDate}`
      if(this.fUpdateDate && this.tUpdateDate) exportURL += `&fUpdateDate=${this.fUpdateDate}&tUpdateDate=${this.tUpdateDate}`
      if(this.searchText && this.searchText != '' && this.searchText != null && this.selectedSearchCat) 
      exportURL += `&search=${this.searchText}&searchcat=${this.selectedSearchCat}`
      if(this.nselect.length != 0) exportURL += `&status=${this.nselect.join('|')}`
      // if(this.shiselect.length != 0) exportURL += `&shistatus=${this.shiselect.join('|')}`
      if(this.deliveryselect.length != 0) exportURL += `&delstatus=${this.deliveryselect.join('|')}`
      if(this.newStatusForAll) exportURL += `&order_status=${this.newStatusForAll}`
      if(this.pselect.length != 0) exportURL += `&products=${this.pselect.join('|')}`
      if(this.fTLDate && this.tTLDate && this.selectedTLStatus) exportURL += `&fTLDate=${this.fTLDate}&tTLDate=${this.tTLDate}&TLStatus=${this.selectedTLStatus}`
      if(this.fSHIDate && this.tSHIDate && this.selectedSHIStatus) exportURL += `&fSHIDate=${this.fSHIDate}&tSHIDate=${this.tSHIDate}&SHIStatus=${this.selectedSHIStatus}`
      if(this.fdelDate && this.tdelDate && this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}&delStatus=${this.selecteddelStatus}`
      if(!this.fdelDate && !this.tdelDate && this.selecteddelStatus) exportURL += `&delStatus=${this.selecteddelStatus}`
      if(this.fdelDate && this.tdelDate && !this.selecteddelStatus) exportURL += `&fdelDate=${this.fdelDate}&tdelDate=${this.tdelDate}`
      if(this.selectedToken) exportURL += `&token=${this.selectedToken.join('|')}`
      if(this.$props.userData.uid) exportURL += `&caller=${this.$props.userData.uid}`
      if(this.userselectcreate) exportURL += `&creator=${this.userselectcreate}`
      if(this.docNumber) exportURL += `&docNumber=${this.docNumber}`
      if(this.paidDate && this.tpaidDate && this.selectedPaidStatus.length) exportURL += `&paidDate=${this.paidDate}&tpaidDate=${this.tpaidDate}&selectedPaidStatus=${this.selectedPaidStatus.join('|')}`
      if(this.selectedReserved) exportURL += `&reserved=${this.selectedReserved}`
      if (this.onlyKitems) exportURL += `&vproducts=${this.onlyKitems}`
      if (this.onlySubvendor) exportURL += `&onlysuborders=${this.onlySubvendor}`
      return exportURL
    },
    exportAlleadsDateStatusPartialDate(row){
      this.exportLoading = true
      let cStart =this.fDate;
      let cEnd = this.tDate;
      let startDate = new Date(cStart)
      let endDate = new Date(cEnd)
      let i = 0;
      let exportLeads = [];
      (async x=>{
        //console.log((endDate - startDate) / (1000 * 3600 * 24))
        var loopDate = new Date(startDate);
        while (loopDate <= endDate) {
          let year = loopDate.getFullYear()
          let month = ((loopDate.getMonth() + 1) < 10) ? "0" + (loopDate.getMonth() + 1) : (loopDate.getMonth() + 1)
          let day = (loopDate.getDate() < 10) ? "0" + loopDate.getDate() : loopDate.getDate()
          let dayName = loopDate.getDay()
          let weekDayes = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          let nDates = weekDayes[dayName] + ' - ' + day + '/' + month + '/' + year
          let sendFDate = new Date(new Date(cStart).getTime() + 24 * 60 * 60 * 1000 * (i*3+(i*1))).toISOString().split('T')[0]
          let tDat = new Date(cStart).getTime() + 24 * 60 * 60 * 1000 * (i*3+4+(i*1))
          let sendTDate = new Date(tDat>endDate? endDate: tDat).toISOString().split('T')[0]
          // console.log(sendFDate)
          // console.log(sendTDate)
          // console.log(i)
          let exportURL = `https://us-central1-ashyaatcrm.cloudfunctions.net/mainCSV/csvItemExportByShippingDateLoop/?=`
          exportURL += this.prepPartialStatusFilterLink()
          exportURL += `&fDate=${sendFDate}&tDate=${sendTDate}`
          exportURL += `&shistatus=${this.shiselect.join('|')}`
          if(row){
            exportURL += `&row=true`
          }
          // console.log(exportURL)
          await this.sleep(5000)
          let a = await axios.get(exportURL).then(x=>x.data)
          exportLeads = [...exportLeads, ...a]
          i++
          // console.log(i)
          var newDate = loopDate.setDate(loopDate.getDate() + i*3 - 4);
          loopDate = new Date(new Date(sendTDate).getTime() + 24*60*60*1000);
        }
        console.log('exportLeads', exportLeads)
        this.exportLoading = false
        this.exportData(exportLeads)
      })()
    },
    exportData(data, name){
      if(!data.length) {
        return true
      }
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'leads_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    async lockByDate(date) {
      return new Promise(async(res, rej)=>{
        let a = await db.ref(`settings/lockdate`).once('value').then(x=>x.val());
        if(a) {
          let d = date
          let b = new Date(d)
          if( b <= a ){
            res(true)
          } else {
            res(false)
          }
        } else {
          res(false)
        }
      })
    },
    async validateBeforeUpdate(lead) {
      return new Promise(async (res, rej)=>{
        let val = true
        if(!lead.ninja && lead.order && lead.order.length != 0) {
          let cval = true
          for (let i = 0; i < lead.order.length; i++) {
            const item = lead.order[i];
            for (const key in item) {
              if (item.hasOwnProperty(key) && key != 'discount') {
                const f = item[key];
                if(f == '' || !f || f == null) {
                  cval = false
                  this.$emit('snackbarNotification', `${key.toUpperCase()} is required`, 'error')
                }
              }
            }
          }
          val = cval
          if(this.$props.userRole != 'admin') {
            val = cval
          }
        }
        if( lead.ninja && lead.order && lead.order.length > 0 ) {
          for (let i = 0; i < lead.order.length; i++) {
            const item = lead.order[i];
            if(!item.sku || !item.product) {
              val = false
              this.$emit('snackbarNotification', `Select an SKU or remove extra item`, 'error')
            } else if(!item.total) {
              val = false
              this.$emit('snackbarNotification', `SKU not available in this country (total 0)`, 'error')
            }
            if (!Number.isInteger(parseFloat(item.quantity))) {
              val = false
              this.$emit('snackbarNotification', `Quantity should be an integer`, 'error')
            }
            if (parseFloat(item.quantity) < 1) {
              val = false
              this.$emit('snackbarNotification', `Quantity should be > 1`, 'error')
            }
          }
        }
        if(!lead.name || lead.name == '') {
          val = false
          this.$emit('snackbarNotification', `Name is required`, 'error')
        }
        if(!lead.phone_number_1 || lead.phone_number_1 == '') {
          val = false
          this.$emit('snackbarNotification', `Phone Number is required`, 'error')
        }
        if(!lead.country || lead.country == '') {
          val = false
          this.$emit('snackbarNotification', `Country is required`, 'error')
        }
        if(!lead.order_source || lead.order_source == '') {
          val = false
          this.$emit('snackbarNotification', `Order Source is required`, 'error')
        }
        if(!lead.gender || lead.gender == '') {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Gender is required`, 'error')
          }
        }
        if(!lead.language || lead.language == '') {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Language is required`, 'error')
          }
        }
        if(!lead.campaign_code || lead.campaign_code == '') {
          val = false
          this.$emit('snackbarNotification', `Campaign Code is required`, 'error')
        }
        if(!lead.company_code || lead.company_code == '') {
          val = false
          this.$emit('snackbarNotification', `Company Code is required`, 'error')
        }
        if(!lead.order_status || lead.order_status == '') {
          if(!lead.new) {
            val = false
            this.$emit('snackbarNotification', `Order Status is required`, 'error')
          }
        }
        if((lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order') && (!lead.address || lead.address == '')) {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Address is required`, 'error')
          }
        }
        if((lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order') && (!lead.wa_number || lead.wa_number == '')) {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `WA Number is required`, 'error')
          }
        }
        if((lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order') && (!lead.city || lead.city == '')) {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `City is required`, 'error')
          }
        }
        if(lead.new){
          if(lead.order.length == 0) {
            val = false
            this.$emit('snackbarNotification', `At least one item is required`, 'error')
          }
        }
        if((lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order' || lead.order_status == 'Dispatch') && lead.order.length == 0) {
          val = false
          this.$emit('snackbarNotification', `Item in Order is required`, 'error')
        }
        if(!lead.agent_name || lead.agent_name == '') {
          val = false
          this.$emit('snackbarNotification', `Agent Name is required`, 'error')
        }
        if(lead.agent_name != this.$props.userName){
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Please select your name in Agent Name`, 'error')
          }
        }
        let lBack =  loadedLeadsForBackup.filter(x=> x.key == lead.key)[0]
        if(lead.order_status == 'Confirmed' && lBack && lBack.order_status && lBack.order_status == 'Confirmed') {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `You dont have permission to edit a confirmed order`, 'error')
          }
        }
        if(lBack && lBack.order_status && lBack.order_status == 'Dispatch') {
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `You dont have permission to edit a Dispatched order`, 'error')
          }
        }
        if(lead.agent_name != this.$props.userName){
          if(this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Please select your name in Agent Name`, 'error')
          }
        }
        if(lead.locked) {
          val = false
          this.$emit('snackbarNotification', `This Order Is Locked For Reservation!`, 'error')
        }
        if(lead.ninja && parseFloat(lead.manual_total) < parseFloat(lead.min_total)) {
          if(!this.$props.superAdmin) {
            val = false
            this.$emit('snackbarNotification', `The Manual total cant be less than ${lead.min_total}`, 'error')
          }
        }
        if( lead.ninja && lead.order_status == 'Confirmed' && parseFloat(lead.float_base_profit) < 0 ) {
          if(!this.$props.superAdmin) {
            val = false
            this.$emit('snackbarNotification', `The profit cant be less than 0`, 'error')
          }
        }
        
        if(lead.ninja && !lead.manual_total) {
          val = false
          this.$emit('snackbarNotification', `Manual Total is Required`, 'error')
        }
        if(lead.manual_total && parseInt(lead.manual_total) > 2000000) {
          val = false
          this.$emit('snackbarNotification', `Manual Total Max is 2000000`, 'error')
        }
        if(!lead.ninja) {
          if(isNaN(lead.total_converted_after_tax)) {
            val = false
            this.$emit('snackbarNotification', `The total is not a number`, 'error')
          }
        }
        // console.log('------------------------------------');
        // console.log(await this.lockByDate(lead.import_date));
        // console.log('------------------------------------');
        if(await this.lockByDate(lead.import_date)){
          if(!this.$props.superAdmin) {
            val = false
            this.$emit('snackbarNotification', `Order Is Locked`, 'error')
          }
        }
        let phOneV = await this.phoneOneValidateOnSave(lead)
        if(lead.new && !phOneV) {
          val = false
          this.$emit('snackbarNotification', `Phone 1 wrong`, 'error')
        }
        if(lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order' || lead.order_status == 'NEW Confirm' || lead.order_status == 'New confirm') {
          if(lead.country && (lead.country == 'KSA' || lead.country == 'Saudi Arabia') && !lead.address_url && this.$props.userRole != 'admin') {
            val = false
            this.$emit('snackbarNotification', `Address URL is required`, 'error')
          }
        }
        res(val)
      })
    },
    addStatus(){
      db.ref('orderstatuses').push({
        name:this.newStatus
      })
      .then(x=>{
        this.orderstatusesLoaded.push(this.newStatus)
        this.newStatus = null
        this.addstatusdialog = false
      })
    },
    addFailedStatus() {
      db.ref('faileddeliverystatuses').push({
        name:this.newFailedStatus
      })
      .then(x=>{
        this.faileddeliverystatusesLoaded.push(this.newStatus)
        this.newFailedStatus = null
        this.faileddeliverystatuses = false
      })
    },
    addShippingStatus(){
      db.ref('shippingstatuses').push({
        name:this.newShippingStatus
      })
      .then(async x=>{
        await db.ref('settings/shippingstatuses').update({
          [this.newShippingStatus.split(' ').join('_').toLowerCase()]:this.newShippingStatusTransaction
        })
        this.newShippingStatusTransaction = null
        this.orderstatusesLoaded.push(this.newShippingStatus)
        this.newShippingStatus = null
        this.addshippingstatusdialog = false
      })
    },
    addCityToCountry(){
      db.ref('countries')
      .once('value')
      .then(s=>{
        let c = s.val()
        let index = c.findIndex(x => x.name === this.newCityCountry)
        db.ref('countries/' + index + '/cities').push({name:this.newCity})
        .then(x=>{
          db.ref('countries/' + index)
          .once('value')
          .then(snap=>{
            let nc = snap.val()
            this.countriesFullLoaded.splice(index, 1, nc)
            this.newCityCountry = null
            this.newCity = null
            this.addcitydialog = null
          })
        })
      })
    },
    readOnly(key, l) {
      let y = ['creator_agent', 'item_name_cross_sell', 'update_date', 'country', 'company_code', 'order_source', 'campaign_code', 'phone_number_1', 'item_name', 'date', 'import_date', 'document_number', 'shipping_status', 'delivery_status', 'payment_url']
      if(l.new){
        return false
      } else if (l.order_status && l.order_status.toLowerCase() == "dispatch" && this.$props.userRole != 'admin'){
        return true
      } else {
        if(y.indexOf(key) != -1) {
          if(this.$props.userRole == 'admin'){
            return false
          } else {
            if(key == 'address' && l.country && (l.country.toLowerCase() == 'iraq' || l.country.toLowerCase() == 'jo' || l.country.toLowerCase() == 'jordan')){
              false
            } else {
              return true
            }
          }
        } else {
          return false
        }
      }
      
    },
    getSettings(){
      return new Promise(async(res, rej)=>{
        this.orderFields = await db.ref('settings/orderFields').once('value').then(x=>x.val())
        let r = ['dialog', 'key', 'baseprice', 'product', 'price']
        this.basicFields = Object.keys(this.orderFields)
        .filter(x => r.indexOf(x) == -1 )
        .sort((a,b) => {
          try {
            return this.orderFields[a].order - this.orderFields[b].order
          } catch (error) {
          }
        })
        await this.loadItems()
        await this.loadNinjaSettings()
        this.loading = false
        res(true)
        
      })
    },
    async getLeadsBySearch() {
      this.loading = true
      this.visibleLeads = []
      this.filteredLeads = []
      this.leads = []
      let search = this.searchPhoneNumber
      // console.log(search);
      if(!search || search == '') {
        this.loading = false
        return true
      }
      search = search.trim()
      let leads1 = await store.collection('leads')
      .where('phone_number_1', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads2 = await store.collection('leads')
      .where('phone_number_2', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads3 = await store.collection('leads')
      .where('phone_number_3', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads4 = await store.collection('leads')
      .where('document_number', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      let leads5 = await store.collection('leads').doc(search).get().then(x=>x.data())
      let leads6 = await store.collection('leads')
      .where('uuid', '==', search)
      .get()
      .then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
      
      let leads = [...leads1, ...leads2, ...leads3, ...leads4, leads5, ...leads6].filter(x=>x)
      // console.log('search store', leads)

      for (const key in leads) {
        if (leads.hasOwnProperty(key)) {
          const lead = leads[key];
          if(!lead.key) lead.key = key
          let nKesys = ['order_status', 'order', 'note', 'update_date', 'address', 'form']
          nKesys.forEach(key=>{
            if ( typeof lead[key] === 'undefined' && key != 'order') 
            lead[key] = null
            if(typeof lead[key] === 'undefined' && key == 'order')
            lead[key] = []
            if(typeof lead[key] === 'undefined' && key == 'form')
            lead[key] = {}
          })
          lead.dialog = false
          if(lead.token && lead.token.includes('GS_DB_')) lead.form = await store.collection("forms").doc(`${lead.token.replace(' Form','')}`).get().then(x=>x.data())
          let index = this.leads.findIndex(x => x.key === lead.key)
          if(index != -1) this.leads.splice(index, 1, lead); 
          if(index === -1) this.leads.push(lead)
          let vindex = this.visibleLeads.findIndex(x => x.key === lead.key)
          if(vindex != -1) this.visibleLeads.splice(vindex, 1, lead); 
          if(vindex === -1) this.visibleLeads.push(lead)
          let findex = this.filteredLeads.findIndex(x => x.key === lead.key)
          if(findex != -1) this.filteredLeads.splice(findex, 1, lead); 
          if(findex === -1) this.filteredLeads.push(lead)
          let bindex = loadedLeadsForBackup.findIndex(x => x.key === lead.key)
          if(bindex != -1) loadedLeadsForBackup.splice(bindex, 1, Object.assign({}, lead)); 
          if(bindex === -1) loadedLeadsForBackup.push(Object.assign({}, lead))
        }
      }

      let allow_manjam_statuses = ["confirmed", "dispatch", 'paid']

      let org = this.visibleLeads
      .sort(function (a, b) {
        return new Date(b.import_date) - new Date(a.import_date);
      })
      .filter(x => x.ninja && !x.manjam && x.order_status && allow_manjam_statuses.includes(x.order_status.toLowerCase().trim()))
      if(org.length) {
        let active = await axios.post(crmApiUrl(`check-if-active`), {ids:org.map(x=>x.account_id)}).then(x=>x.data)
        let active_accounts = active.accounts
        let elig = org.filter(x=> active_accounts.includes(x.account_id))
        if(elig.length) {
          this.visibleLeads.filter(x=>x.key !== elig[0].key).forEach(x=> x.allowCreate = false)
          this.visibleLeads.filter(x=>x.key === elig[0].key)[0].allowCreate = true
        }
      }

      this.getPagesNumber()
      this.updateVisible()      
    },
    // getCampaignsIds() {
    //   this.loading = true
    //   this.visibleLeads = []
    //   this.filteredLeads = []
    //   db.ref('leads/')
    //     .limitToLast(50)
    //     .once('value')
    //     .then(snap=>{
    //       let leads = snap.val()
    //       for (const key in leads) {
    //         if (leads.hasOwnProperty(key)) {
    //           const lead = leads[key];
    //           lead.key = key
    //           let nKesys = ['order_status', 'order', 'note', 'update_date', 'address']
    //           nKesys.forEach(key=>{
    //             if ( typeof lead[key] === 'undefined' && key != 'order') 
    //             lead[key] = null
    //             if(typeof lead[key] === 'undefined' && key == 'order')
    //             lead[key] = []
    //           })
    //           let nSearch = ['date', 'import_date', 'key', 'update_date', 'status_timeline']
    //           this.searchCats = Object.keys(lead)
    //           .filter(x => nSearch.indexOf(x) == -1 )
    //           .map(x => x.toUpperCase())
    //           lead.dialog = false
    //           if (this.countries.indexOf(lead.country == -1)) this.countries.push(lead.country)
    //           if (this.campaigns.indexOf(lead.campaign_code.toUpperCase() == -1)) this.campaigns.push(lead.campaign_code.toUpperCase())
    //           if (this.contents.indexOf(lead.utm_content == -1)) this.contents.push(lead.utm_content)
    //           if (this.referrers.indexOf(lead.order_source == -1)) this.referrers.push(lead.order_source)
    //           if(this.companycodes.indexOf(lead.company_code.toUpperCase() == -1)) this.companycodes.push(lead.company_code.toUpperCase())
    //           let index = this.leads.findIndex(x => x.key === lead.key)
    //           if(index != -1) this.leads.splice(index, 1, lead); 
    //           if(index === -1) this.leads.push(lead)
    //           let bindex = loadedLeadsForBackup.findIndex(x => x.key === lead.key)
    //           if(bindex != -1) loadedLeadsForBackup.splice(bindex, 1, Object.assign({}, lead)); 
    //           if(bindex === -1) loadedLeadsForBackup.push(Object.assign({}, lead))
    //         }
    //       }
    //       this.visibleLeads = this.leads
    //       this.filteredLeads = this.leads
    //       this.getPagesNumber()
    //       this.updateVisible()
    //     })
    // },
    updateVisible() {
      this.sortByDate()
      this.visibleLeads = this.filteredLeads.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredLeads = this.filteredLeads.sort(function(a,b){
        return new Date(b.import_date) - new Date(a.import_date);
      });
    },
    getPagesNumber(){
      if (this.filteredLeads.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize) + 1
      }
    },
    getStatus(b) {
      if(b.order_status && b.order_status.toLowerCase() == 'confirmed') return `success`
      if(b.order_status && b.order_status.toLowerCase() == 'dispatch') return `success`
      if(b.order_status && b.order_status.toLowerCase() == 'paid') return `success`
      if(b.order_status && b.order_status.toLowerCase() != 'confirmed') return `error`
      if(!b.processed) return `warning`
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    selectVisible(t){
      this.selectedLeads = []
      if (this.selectVs) {
        this.selectedLeads = this.visibleLeads
      } else {
        this.selectedLeads = []
      }
      if (this.selectRs) {
        this.selectedLeads = this.filteredLeads
      } else if (!this.selectVs) {
        this.selectedLeads = []
      }
    },
    selectForEdit(b){
      this.selectVs = false
      this.selectRs = false
      this.selectedLeads = []
      this.selectedLeads.push(b)
    },
    async getLeadsToCheck(){
      this.nselect = ['NEED CHECK']
      // await this.getDataStats()
      this.selectedLeads = this.allLeadsLoaded
      .filter(lead=>{ //status
        if(this.nselect.length == 0) {
          return lead
        } else {
          if (this.nselect.indexOf('No Status') != -1 && lead.order_status == (null || '')) {
            return lead
          } else {
            if(lead.order_status && this.nselect.map(x=>x.toUpperCase()).indexOf(lead.order_status.toUpperCase()) != -1) {
              return lead
            }
          }
        }
      })
      .slice(0, 50)
      this.dialogs.numbers = true
      // console.log(this.selectedLeads)
    },
    async phoneOneValidateOnSave(l){
      return new Promise(async (res, rej)=>{
        let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
        let phoneOne = l.phone_number_1
        axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneOne}&cc=${country.alpha2Code}`)
        .then(resp=>{
          if(resp.data.corrected && resp.data.g.isValidNumber) {
            res(true)
          } else {
            res(false)
          }
        })
      })
    },
    checkNumberOneApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneOne = l.phone_number_1
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneOne}&cc=${country.alpha2Code}`)
      .then(resp=>{
        // console.log(resp)
        if(resp.data.corrected && resp.data.g.isValidNumber) {
          this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_1 = resp.data.corrected ? resp.data.corrected : phoneOne
          this.$emit('snackbarNotification', `Phone 1 Corrected`, 'success')
        } else {
          this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
        }
      })
    },
    checkNumberTwoApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneTwo = l.phone_number_2
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
      .then(resp=>{
        // console.log(resp)
        if(resp.data.corrected && resp.data.g.isValidNumber) {
          this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_2 = resp.data.corrected ? resp.data.corrected : phoneTwo
          this.$emit('snackbarNotification', `Phone 1 Corrected`, 'success')
        } else {
          this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
        }
      })
    },
    checkNumberThreeApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneTwo = l.phone_number_3
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
      .then(resp=>{
        // console.log(resp)
        if(resp.data.corrected && resp.data.g.isValidNumber) {
          this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_3 = resp.data.corrected ? resp.data.corrected : phoneTwo
          this.$emit('snackbarNotification', `Phone 1 Corrected`, 'success')
        } else {
          this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
        }
      })
    },
    saveCorrectedNumbers(l) {
      this.loading = true
      let key = l.key
      delete l.dialog
      delete l.new
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneOne = l.phone_number_1
      let phoneTwo = l.phone_number_2
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneOne}&cc=${country.alpha2Code}`)
      .then(resp=>{
        if(resp.data.corrected && resp.data.g.isValidNumber) {
          this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_1 = resp.data.corrected ? resp.data.corrected : phoneOne
          axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
          .then(resp=>{
            if(resp.data.corrected && resp.data.g.isValidNumber) {
              this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_2 = resp.data.corrected ? resp.data.corrected : phoneTwo
              l.order_status = 'NEW'
              this.saveCorrectedAfterRecheck(l)
            } else {
              this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_2 = null
              l.order_status = 'NEW'
              this.saveCorrectedAfterRecheck(l)
            }
          })
        } else {
          axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
          .then(resp=>{
            if(resp.data.corrected && resp.data.g.isValidNumber) {
              this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_1 = resp.data.corrected ? resp.data.corrected : phoneOne
              this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_2 = null
              l.order_status = 'NEW'
              this.saveCorrectedAfterRecheck(l)
            } else {
              l.order_status = 'Cancel wrong number'
              this.saveCorrectedAfterRecheck(l)
            }
          })
        }
      })
      
    },
    async saveCorrectedAfterRecheck(l){
      // console.log('------------------------------------');
      // console.log(l);
      // console.log('------------------------------------');
      l.update_date = getCDate()
      let bLead = loadedLeadsForBackup.filter(lead=> lead.key == l.key)[0]
      // console.log(l)
      await store.collection('leads').doc(l.key).set(l)
      this.$emit('snackbarNotification', `Corrected Lead Saved`, 'success')
      this.loading = false
      let index = this.selectedLeads.findIndex(x => x.key === l.key)
      if(index != -1) this.selectedLeads.splice(index, 1); 
      await db.ref('backup').push({
        key:l.key,
        bLead,
        date:getCDate()
      })
      // db.ref(`leads/${l.key}`)
      // .update(l)
      // .then(x=>{
      //   this.$emit('snackbarNotification', `Corrected Lead Saved`, 'success')
      //   this.loading = false
      //   let index = this.selectedLeads.findIndex(x => x.key === l.key)
      //   if(index != -1) this.selectedLeads.splice(index, 1); 
      //   db.ref('backup').push({
      //     key:l.key,
      //     bLead,
      //     date:getCDate()
      //   })
      // })
    },
    getSelected(){
      let x = this.selectedLeads
    },
    triggerUpdate(){
      this.loading = true
      setTimeout(x=>{
        this.updateAllSelected()
      }, 500)
    },
    resetEmbed() {
      this.$emit('resetEmbed')
    },
    async initGetDeliveryFees(key, l) {
      var cc 
      if(l.country.includes('Palestin')) {
        cc = 'PS'
      } else if(l.country.includes('Egypt')) {
        cc = 'EG'
      } else if(l.country.includes('Libya')) {
        cc = 'LY'
      } else if(l.country.includes('Morocco')) {
        cc = 'MA'
      } else if(l.country.includes('Saudi Arabia') || l.country.includes('KSA')) {
        cc = 'SA'
      } else if(l.country.includes('United') || l.country.includes('UAE')) {
        cc = 'AE'
      } else if(l.country.includes('Jordan') || l.country.includes('JO')) {
        cc = 'JO'
      } else if(l.country.includes('Oman') || l.country.includes('OM')) {
        cc = 'OM'
      } else if(l.country.includes('Bahrain') || l.country.includes('BH')) {
        cc = 'BH'
      } else if(l.country.includes('Iraq') || l.country.includes('IQ')) {
        cc = 'IQ'
      } else if(l.country.includes('Kuwait') || l.country.includes('KW')) {
        cc = 'KW'
      } 
      let city_name = this.countriesFullLoaded.filter(x=>x.alpha2Code == cc)[0].cities.filter(x=>x && x.name)[0].name
      const target_city = {new:l.city}
      console.log('target_city', target_city)
      l.city = city_name
      console.log('l.city', l.city)
      await this.getDeliveryFees(key, l)
      l.city = target_city.new
      console.log('l.city', l.city)
      await this.getDeliveryFees(key, l)
    },
    async getDeliveryFees(key, l) {
      return new Promise(async (res, rej)=>{
        if(l.country && l.city) {
          try {
            var cc 
            if(l.country.includes('Palestin')) {
              cc = 'PS'
            } else if(l.country.includes('Egypt')) {
              cc = 'EG'
            } else if(l.country.includes('Libya')) {
              cc = 'LY'
            } else if(l.country.includes('Morocco')) {
              cc = 'MA'
            } else if(l.country.includes('Saudi Arabia') || l.country.includes('KSA')) {
              cc = 'SA'
            } else if(l.country.includes('United') || l.country.includes('UAE')) {
              cc = 'AE'
            } else if(l.country.includes('Jordan') || l.country.includes('JO')) {
              cc = 'JO'
            } else if(l.country.includes('Oman') || l.country.includes('OM')) {
              cc = 'OM'
            } else if(l.country.includes('Bahrain') || l.country.includes('BH')) {
              cc = 'BH'
            } else if(l.country.includes('Iraq') || l.country.includes('IQ')) {
              cc = 'IQ'
            } else if(l.country.includes('Kuwait') || l.country.includes('KW')) {
              cc = 'KW'
            } 
            let fees = this.countriesFullLoaded.filter(x=>x.alpha2Code == cc)[0].cities.filter(x=>x && x.name).filter(x=>x.name == l.city)[0].fees
            console.log(l.city)
            console.log(fees)
            l.delivery_fees = 0
            l.delivery_fees = fees ? fees : 0
            if(l.ninja && l.order && l.order.length) {
              l.base_delivery_fees = 0
              l.cart_delivery_fees = 0
              l.base_delivery_fees = l.delivery_fees
              l.cart_delivery_fees = parseFloat(l.delivery_fees) * parseFloat(l.currency_factor)
              l.order[0].quantity++
              l.order[0].quantity--
              await this.checkMinPrice(l)
            }
            res(true)
            console.log('min and totals done')
            this.getTotal(l, key)
            this.getTotalAfterTax(l, key)
            
          } catch (e) {console.log(e); res(true);}
        }
      })
    },
    async setDispatchDate(key, l){
      let lBack =  loadedLeadsForBackup.filter(x=> x.key == l.key)[0]
      if(l.order_status == 'Confirmed' && (!lBack || !lBack.order_status || lBack.order_status != 'Confirmed')) {
        if(!l.dispatch_date || l.dispatch_date == ''){
          await store.collection('leads').doc(key).update({
            dispatch_date:getCDate()
          })
          // await db.ref(`leads/${key}`).update({
          //   dispatch_date:getCDate()
          // })
        }
      }
    },
    async setLastDispatchDate(key, l){
      let lBack =  loadedLeadsForBackup.filter(x=> x.key == l.key)[0]
      if(lBack && lBack.order_status != 'dispatch') {
        if(l.order_status == 'dispatch'){
          await store.collection('leads').doc(key).update({
            final_dispatch_date:getCDate(),
            final_dispatch_agent:this.$props.userName
          })
          // await db.ref(`leads/${key}`).update({
          //   dispatch_date:getCDate()
          // })
        }
      }
    },
    async getJobNumbers(id) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        // console.log('get', id)
        // var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id});
        let a = await axios.post(apiBase +'/getJobNumber', {id}, {headers}).then(x=>x.data)
        res(a.result)
      })
    },
    async deleteNumbersFromJob(id, numbers) {
      return new Promise(async (res, rej)=>{
        // add numbers to job JOB > ID + NUMBERS (Formated)
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});

        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/deleteJobNumber',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          // console.log(error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            return error.response
          }
        });
        res(r.data)
      })
    },
    async setJobStatus(id, action) {
      return new Promise(async (res, rej)=>{
        // check job status by ID in a JOB > ID
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"action":action});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/changeJobStatus',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };
        try {
          let r = await axios(config)
          .then(x=>x)
          .catch(function (error) {
            // console.log(error);
          });
          res(r.data)
        } catch (error) {
          // console.log(error)
        }
        
      })
    },
    async resetJobNumbers(id, numbers) {
      return new Promise(async (res, rej)=>{
        // check number status by numbers in a JOB > ID + NUMBERS
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","reset_type":"RESETNUMBER","job_id":id,"numbers":numbers});
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/resetJob',
          headers: { 
            'Content-Type': 'application/json'
          },
          data
        };

        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          console.log(error);
        });
        res(r.data)
      })
    },
    async addNumbersToJob(id, numbers) {
      return new Promise(async (res, rej)=>{
        // add numbers to job JOB > ID + NUMBERS (Formated)
        var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id,"numbers":numbers});
        // console.log(data)
        // [{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658759882,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"},{"job_fname":"fname","job_lname":"last","job_max_try":"1","job_address":"add","job_email_id":"na@gmail.com","number":93658799881,"key":"-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf|-Mdwninfafalfnawfialhwf"}]
        var config = {
          method: 'post',
          url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/addJobNumber',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        let r = await axios(config)
        .then(x=>x)
        .catch(function (error) {
          // console.log(error);
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            return error.response
          }
        });
        res(r.data)
      })
    },
    async getJobStatus(id) {
      return new Promise(async (res, rej)=>{
        // check job status by ID in a JOB > ID
        try {
          var data = JSON.stringify({"token":"WFtT8nBwJOKB6ecq4Ulb","job_id":id});
          var config = {
            method: 'post',
            url: 'https://cc.ashyaat.org/HoduCC_api/v1.4/getJobStatus',
            headers: { 
              'Content-Type': 'application/json'
            },
            data
          };
          let r = await axios(config)
          .then(x=>x)
          .catch(function (error) {
            // console.log(error);
          });
          res(r ? r.data : r)
        } catch (error) {
          // console.log(error)
        }
      })
    },
    async UpdateLeadCallCenter(lead){
      return new Promise(async (res, rej)=>{
        let actions = await db.ref('settings/callcenter/actions').once('value').then(x=>x.val())
        // console.log('actions', actions)
        let status = lead.order_status
        // console.log('status', status)
        let lead_action = actions.filter(x=> x && x.do && x.do != 'NOTHING').filter(x=> x.status == status) 
        if(lead_action.length || lead.new_switch) {
          let action = lead_action.length && lead_action[0] ? lead_action[0].do : 'NOTHING'
          // console.log('action', action)
          let call_rules = await store.collection('callcenter').get().then(x=>x.docs.map((y, i)=>{
            return {
              ...y.data(), 
              key:y.id,
            }
          }))
          lead.company_code = lead.company_code.toUpperCase()
          let filter = call_rules.filter(x=>x.companycode.toUpperCase() == lead.company_code)
          if(filter && filter.length) {
            let jobs = filter[0].jobs;
            // console.log('jobs', jobs)
            for (let i = 0; i < jobs.length; i++) {
              const job = jobs[i];
              // console.log('job.job.job_id', job.job.job_id)
              let numbers_call = await this.getJobNumbers(job.job.job_id)
              let numbers = numbers_call.data ? numbers_call.data
              .filter(x=> x.number == lead.phone_number_1) : []
              if(numbers.length){
                if(action == 'REMOVE') {
                  // console.log('REMOVE')
                  let r = await this.deleteNumbersFromJob(job.job.job_id, [lead.phone_number_1])
                  // console.log(r)
                } else if (action == 'RESET') {
                  // console.log('RESET')
                  let st = await this.getJobStatus(job.job.job_id)
                  // console.log(st)
                  if(st.data.job_status == 'RUNNING' || st.data.job_status == 'SCHEDULED') {
                    let pauseJob = await this.setJobStatus(job.job.job_id, 'PAUSE');
                    // console.log(pauseJob)
                  }
                  let r = await this.resetJobNumbers(job.job.job_id, [lead.phone_number_1])
                  // console.log(r)
                  if(st.data.job_status == 'RUNNING' || st.data.job_status == 'SCHEDULED') {
                    let activateJob = await this.setJobStatus(job.job.job_id, 'RESUME');
                    // console.log(activateJob)
                  }
                }
              }
              if(lead.new_switch && numbers_call.data && numbers_call.data.length) {
                let numbers = numbers_call.data
                .filter(x=> x.number == lead.phone_number_2)
                if(numbers.length){
                  // console.log('REMOVE PH2 (old PH1)')
                  let r = await this.deleteNumbersFromJob(job.job.job_id, [lead.phone_number_2])
                  // console.log(r)
                }
              }
            }
            let newJob = filter[0].jobs.filter(x=>x.status = 'NEW')
            if(newJob.length && lead.new_switch) {
              let job = newJob[0]
              // console.log('ADD PH1 (old PH2)')
              let r = await this.addNumbersToJob(job.job_id, [lead.phone_number_1])
              // console.log(r)
              // console.log('Update Lead Not to Switch Again')
              await store.collection('leads').doc(lead.key).update({new_switch:false, order_status:'NEW'})
            } else {
              res(true)
            }
            res(true)
          } else {
            res(true)
          }
        } else {
          res(true)
        }
      })
    },
    async updateAllSelected(){
      (async x=>{
        for (let i = 0; i < this.selectedLeads.length; i++) {
          const l = this.selectedLeads[i];
          if(l.ninja) {
            this.checkMinPrice(l)
          }
          if(l.ninja && l.manual_total) {
            l.total_invoice_converted = l.manual_total
          }
          let v = await this.validateBeforeUpdate(l)
          console.log(v)
          if(v){
            let key = l.key
            delete l.dialog
            delete l.new
            l.wanumbers = null
            if(l.wanumbers) {
              delete l.wanumbers
            }
            l.fet_address = null
            if(l.fet_address) {
              delete l.fet_address
            }
            
            this.recordStatusDate(key, l)
            this.setDispatchDate(key, l)
            this.setLastDispatchDate(key, l)
            l.update_date = getCDate()
            let bLead = loadedLeadsForBackup.filter(lead=> lead.key == key)[0]
            await store.collection('leads').doc(key)
            //db.ref(`leads/${key}`)
            .update(l)
            .then(async x=>{
              this.sendWANotification(l)
              // this.storeAgentTotal(l)
              
              let status = l.order_status ? l.order_status.split(' ').join('_').toLowerCase() : 'Update'
              let bb = await db.ref('uKeys').push()
              if(!l.update_timeline) l.update_timeline = {}
              l.update_timeline[bb.key] = {
                  status:status,
                  agent:this.$props.userName,
                  date:getCDate()
                }
              store.collection('leads').doc(key).update(l)
              this.resetEmbed()
              await db.ref('uKeys').update({
                [bb.key]:null
              })
              
              // db.ref(`leads/${key}/update_timeline`).push({
              //   status:status,
              //   agent:this.$props.userName,
              //   date:getCDate()
              // })
              .then( async x=>{
                if(l.voucher) {
                  await db.ref(`vouchers/${l.voucher.uid}`).update({
                    active:false,
                    used:true
                  })
                }
                if(bLead) {
                  try {
                    await db.ref('backup').push({
                      key,
                      bLead,
                      date:getCDate()
                    })
                  } catch(error) {}
                }
              })
            })
            l.key = key
            try {
              await this.UpdateLeadCallCenter(l)
            } catch (error) {}
            if (i == this.selectedLeads.length - 1) {
              this.dialogs.editing = false
              this.$emit('snackbarNotification', `All Selected Leads Updated`, 'success')
              this.loading = false
              this.selectedLeads = []
            }

          } else {
            this.loading = false
          }
        }
      })()
    },
    async backUpdate(){
      this.loading = true;

      (async x=>{
        for (let i = 0; i < this.selectedLeads.length; i++) {
          const l = this.selectedLeads[i];
          if(l.ninja) {
            this.checkMinPrice(l)
          }
          if(l.ninja && l.manual_total) {
            l.total_invoice_converted = l.manual_total
          }
          let v = await this.validateBeforeUpdate(l)
          if(v){
            console.log(JSON.stringify(l))
            console.log(l)
            let r = await axios.post(`https://us-central1-ashyaatcrm.cloudfunctions.net/updatelead/updateLead`, {l, user:this.$props.userName}, {headers}).then(x=>x.data)
            if(!r.status) {
              this.$emit('snackbarNotification', `Update Error`, 'error')
            }
            if (i == this.selectedLeads.length - 1) {
              
            }
          } else {
            this.loading = false
            return false
          }
        }
        this.$emit('snackbarNotification', `All Selected Leads Updated`, 'success')
        this.dialogs.editing = false
        this.loading = false
        this.selectedLeads = []
      })()
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async sendWANotification(lead){
      // console.log(lead)
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      let b = Object.keys(a)
      let settings_cc = Object.values(a).map((x, i)=>{
        return {
          ...x,
          key:b[i]
        }
      })
      function getPolicyLink(cc){
        let pl = settings_cc.filter(x=>cc && x.company_code == cc.toUpperCase())
        if(pl.length) {
          return pl[0].policy
        } else {
          return "https://www.ashyaat.net/the-return-policy-ar"
        }
      }
      function getDeliveryDays(cc){
        let pl = settings_cc.filter(x=>cc && x.company_code == cc.toUpperCase())
        if(pl.length) {
          return pl[0].ddays
        } else {
          return '3-8'
        }
      }
      let msgSettings = {
        arMale: {
          name:``,
          payment_url:null,
          order:``,
          total:``,
          delivery: `${getDeliveryDays(lead.company_code)}`,
          online_total:null,
          message: function(){ 
            return `عميلنا العزيز السيد ${this.name},\n\n`+
            `تم تأكيد طلبكم وهو عباره عن:\n`+
            `${this.order}`+
            `اجمالي قيمة الطلب ${this.total}\n`+
            `${parseFloat(lead.tax)>0 ? 'شامل الضريبة' : ''}\n`+
            `سيتم التواصل معكم من قبل شركة التوصيل خلال ${this.delivery} يام لاستلام الطلب\n\n`+
            // `سيتم التواصل معكم من قبل شركة التوصيل خلال 7-10 أيام لاستلام الطلب , قد يطرأ تأخير على طلبك ليصل بعد العيد\n\n`+

            `${this.payment_url && this.online_total ? 'وفر فلوسك و احصل على خصم و سعر اقل عند دفعك لطلبك اونلاين عن طريق بطاقة مدى،فيزا،ماستر كارد ادفع اونلاين اضغط على هذا رابط\n' : ''}`+
            `${this.payment_url && this.online_total ? this.payment_url + '\n\n' : ''}`+

            `لسياية التبديل والارجاع اضغط الرابط في الاسفل : ${getPolicyLink((lead.company_code))} \n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        arFemale:{
          name:``,
          payment_url:null,
          order:``,
          total:``,
          delivery: `${getDeliveryDays(lead.company_code)}`,
          online_total:null,
          message: function(){ 
            return `عميلتنا العزيزة السيدة ${this.name},\n\n`+
            `تم تأكيد طلبكم وهو عباره عن:\n`+
            `${this.order}`+
            `اجمالي قيمة الطلب ${this.total}\n`+
            `${parseFloat(lead.tax)>0 ? 'شامل الضريبة' : ''}\n`+
            `سيتم التواصل معكم من قبل شركة التوصيل خلال ${this.delivery} يام لاستلام الطلب\n\n`+
            // `سيتم التواصل معكم من قبل شركة التوصيل خلال 7-10 أيام لاستلام الطلب , قد يطرأ تأخير على طلبك ليصل بعد العيد\n\n`+

            `${this.payment_url && this.online_total ? 'وفر فلوسك و احصل على خصم و سعر اقل عند دفعك لطلبك اونلاين عن طريق بطاقة مدى،فيزا،ماستر كارد ادفع اونلاين اضغط على هذا رابط\n\n' : ''}`+
            `${this.payment_url && this.online_total ? this.payment_url + '\n\n' : ''}`+

            `لسياية التبديل والارجاع اضغط الرابط في الاسفل: ${getPolicyLink((lead.company_code))} \n\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        enMale:{
          name:``,
          payment_url:null,
          order:``,
          total:``,
          delivery: `${getDeliveryDays(lead.company_code)}`,
          online_total:null,
          message:function(){
            return `Dear valued customer Mr. ${this.name},\n` +
            `Your order has been confirmed which contains:\n` +
            `${this.order}` +
            `and the total order amount is ${this.total}\n` +
            `${parseFloat(lead.tax)>0 ? 'including tax' : ''}\n`+
            `The delivery company will contact with you in ${this.delivery} days to arrange the delivery time.\n\n`+
            // `The delivery company will contact with you in 7-10 days to arrange the delivery time. It may as well get delayed to after Iftar Eid Holiday\n\n`+

            `${this.payment_url && this.online_total ? 'Discounted Payment link\n' : ''}`+
            `${this.payment_url && this.online_total ? this.payment_url + '\n\n' : ''}`+

            `For return policy , please click the link below: ${getPolicyLink((lead.company_code))} \n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n`
          }
        },
        enFemale:{
          name:``,
          payment_url:null,
          order:``,
          total:``,
          online_total:null,
          delivery: `${getDeliveryDays(lead.company_code)}`,
          message:function(){
            return `Dear valued customer Ms. ${this.name},\n` +
            `Your order has been confirmed which contains:\n` +
            `${this.order}` +
            `and the total order amount is ${this.total}\n` +
            `${parseFloat(lead.tax)>0 ? 'including tax' : ''}\n`+
            `The delivery company will contact with you in ${this.delivery} days to arrange the delivery time.\n\n`+
            // `The delivery company will contact with you in 7-10 days to arrange the delivery time. It may as well get delayed to after Iftar Eid Holiday\n\n`+
            `${this.payment_url && this.online_total ? 'Discounted Payment link\n' : ''}`+
            `${this.payment_url && this.online_total ? this.payment_url + '\n\n' : ''}`+


            `For return policy , please click the link below: ${getPolicyLink((lead.company_code))} \n\n`+
            `Have a good day\n`+
            `Ashyaat customer service team.\n` 
          }
        },
      }  
      
      if(lead.order.length != 0 
      && (lead.order_status == 'Confirmed' || lead.order_status == 'pending payment' || lead.order_status == 'Payment Order')
      && lead.order_status != 'Dispatch'
      // && lead.status_timeline
      // && lead.status_timeline.confirmed
      // && lead.status_timeline.confirmed.date
      ){
        // let nowDate = new Date()
        // let dayDate = nowDate.getDate();
        // let confirmDate = new Date(lead.status_timeline.confirmed.date)
        // let dayConfirm = confirmDate.getDate();
        if(true) { // dayDate == dayConfirm
          let msgObj = msgSettings[lead.language + lead.gender]

          msgObj.payment_url = lead.payment_url ? lead.payment_url : null
          msgObj.online_total = lead.online_total && lead.online_total != '' ? lead.online_total : null

          msgObj.name = lead.name
          let order = lead.order
          let productsImages = []
          let notOrder = ''
          order.forEach(item=>{
            notOrder += `${item.quantity} X ${item.name_ar}\n`
            if(item.sku) {
              let f = this.productsFullLoaded.filter(p => p.sku == item.sku)
              if(f && f[0]) {
                if(f[0].img){
                  productsImages.push({
                    img:f[0].img,
                    name:f[0]['name_'+ lead.language],
                  })
                }
              }
            }
          })
          msgObj.order = notOrder
          msgObj.total = lead.tax ? lead.total_converted_after_tax : this.getTotal(lead, lead.key)
          if(lead.manual_total) {
            msgObj.total = lead.manual_total
          }
          // console.log(msgObj.message())
          let lang_temp = lead.language == 'ar' ? 'ar' : 'en'
          // normal confirm
          // let template1 = {
          //   name:`confirmation`,
          //   namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
          //   language: lang_temp,
          //   components:[
          //     {
          //         "type": "header",
          //         "parameters": [
          //             {
          //                 "type": "text",
          //                 "text": msgObj.name
          //             }
          //         ]
          //     },
          //     {
          //         "type": "body",
          //         "parameters": [
          //             {
          //                 "type": "text",
          //                 "text": msgObj.name
          //             },
          //             {
          //                 "type": "text",
          //                 "text": msgObj.order.replace(/\n/g, ' | ')
          //             },
          //             {
          //                 "type": "text",
          //                 "text": msgObj.total
          //             },
          //             {
          //                 "type": "text",
          //                 "text": msgObj.delivery
          //             },
          //             {
          //                 "type": "text",
          //                 "text": getPolicyLink((lead.company_code ? lead.company_code.toUpperCase() : ''))
          //             },
          //         ]
          //     }
          //   ]
          // }
          // confirm with online total
          let template2 = {
            name:`confarmation_with_p`,
            namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
            language: lang_temp,
            components:[
              {
                  "type": "header",
                  "parameters": [
                      {
                          "type": "text",
                          "text": msgObj.name
                      }
                  ]
              },
              {
                  "type": "body",
                  "parameters": [
                      {
                          "type": "text",
                          "text": msgObj.name
                      },
                      {
                          "type": "text",
                          "text": msgObj.order.replace(/\n/g, ' | ')
                      },
                      {
                          "type": "text",
                          "text": msgObj.total
                      },
                      {
                          "type": "text",
                          "text": msgObj.delivery
                      },
                      {
                          "type": "text",
                          "text": getPolicyLink((lead.company_code ? lead.company_code.toUpperCase() : ''))
                      },
                  ]
              },
              {
                "type": "button",
                "sub_type": "url",
                "index": "0",
                "parameters": [
                  {
                    "type": "text",
                    "text": lead.payment_url ? lead.payment_url.replace('https://ashyaatpayment.web.app/p/', '') : null
                  }
                ]
              }
            ]
          }

          let template3 = {
            name:`confirm_all`,
            namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
            language: lang_temp,
            components:[
              {
                  "type": "header",
                  "parameters": [
                      {
                          "type": "text",
                          "text": msgObj.name
                      }
                  ]
              },
              {
                  "type": "body",
                  "parameters": [
                      {
                          "type": "text",
                          "text": msgObj.name
                      },
                      {
                          "type": "text",
                          "text": msgObj.order.replace(/\n/g, ' | ')
                      },
                      {
                          "type": "text",
                          "text": msgObj.total
                      },
                      {
                          "type": "text",
                          "text": msgObj.delivery
                      },
                  ]
              },
              {
                "type": "button",
                "sub_type": "url",
                "index": "0",
                "parameters": [
                  {
                    "type": "text",
                    "text": getPolicyLink((lead.company_code ? lead.company_code.toUpperCase() : ''))
                    .replace('https://ashyaat.com/p/', '')
                  }
                ]
              }
            ]
          }
          let template1 = template3
          let template = lead.payment_url && lead.online_total ? template2 : template3
          // console.log(JSON.stringify(template))
          // let post = {
          //   number:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
          //   message:msgObj.message(),
          //   country:lead.company_code.toUpperCase(),
          //   template
          // }
          // const api = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
          // const headers = {
          //   'Accept': 'application/json'
          // }
          // let send = await axios.post(`//WA API//`, post, {headers:headers}).then(x=>x.data)
          // // console.log(send)
          // if(send.success) {
          //   this.sending = false
          //   this.sMessage = null
          //   this.file = null
          //   this.imgURL = null
          //   this.imgURLExt = null
          //   this.loading = false
          //   this.nNumber = null
          //   this.dialog = false
          // } else if(send.qr){
          //   this.dialogs.qr = true
          //   this.loading = false
          //   this.qrCode = send.qr
          //   this.$emit('snackbarNotification', `Please scan ${send.number} QR code`, 'error')
          // } else {
          //   // console.log(send)
          //   this.$emit('snackbarNotification', `${send.message}`, 'error')
          // }
          // let myNumber = '96262000040' //'96262000045'
          // if(lead.company_code && lead.company_code.toUpperCase() == 'ASHYAAT JO') {
          //   myNumber = '962796041616'
          // } else if(lead.company_code && lead.company_code.toUpperCase() == 'TELEMARKETING') {
          //   myNumber = '96262008683'
          // } else if(lead.company_code && lead.company_code.toUpperCase() == 'ASHYAAT IRAQ') {
          //   myNumber = '9647806233331'
          // }
          // let n = await db.ref(`settings/wa/${myNumber}`)
          // .once('value')
          // .then(x=>x.val());
          
          // axios.get(`${n.instance}status?token=${n.token}`)
          // .then(resp => {
          //   if (resp.data.qrCode) {
          //     this.dialogs.qr = true
          //     this.qrCode = resp.data.qrCode
          //     this.$emit('snackbarNotification', `Please scan ${myNumber} QR code`, 'success')
          //   } else if(resp.data.accountStatus == 'authenticated'){
          //     this.dialogs.qr = false
          //     this.qrCode = null
          //     this.$emit('snackbarNotification', `Ready to send`, 'success');
          //     var headers = {
          //       'Accept': 'application/json'
          //     }
          //     let post = {
          //       phone:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
          //       body:msgObj.message()
          //     }
          //     axios.post(`${n.instance}sendMessage?token=${n.token}`, post, {headers: headers})
          //     .then(resp=>{
          //       if (resp.data.sent) {
          //         this.$emit('snackbarNotification', `Customer Notified on Confirmation in WA`, 'success')
          //       }
          //     })
          //     if(false){
          //       (async ()=>{
          //         for (let iM = 0; iM < productsImages.length; iM++) {
          //           const img = productsImages[iM];
          //           let post = {
          //             phone:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
          //             body:img.img,
          //             filename:'ashyaat.jpg',
          //             caption:img.name
          //           }
          //           await this.sleep(10000)
          //           await axios.post(`${n.instance}sendFile?token=${n.token}`, post, {headers: headers})
          //           .then(x=>{
          //             if(iM == productsImages.length - 1 ){
          //               var headers = {
          //                 'Accept': 'application/json'
          //               }
          //               let post = {
          //                 phone:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
          //                 body:msgObj.message()
          //               }
          //               axios.post(`${n.instance}sendMessage?token=${n.token}`, post, {headers: headers})
          //               .then(resp=>{
          //                 if (resp.data.sent) {
          //                   this.$emit('snackbarNotification', `Customer Notified on Confirmation in WA`, 'success')
          //                 }
          //               })
          //             }
          //           })
          //         }
          //       })()
          //     } else {
                
          //     }
          //   } else {
          //     this.loading = false
          //     this.$emit('snackbarNotification', `Please Login to chat-api.com and click USE HERE`, 'success')
          //     setTimeout(x=>{
          //       window.open('https://app.chat-api.com/')
          //     }, 2000)
          //   }
          // })
        }
      }
    },
    async storeAgentTotal(l){
      let add = ['Confirmed', 'Dispatch']
      let lBack =  loadedLeadsForBackup.filter(x=> x.key == l.key)[0]
      if(l.order_status == 'Confirmed' && (!lBack || !lBack.order_status || lBack.order_status != 'Confirmed')) {
        if(this.$props.userData){
          let uid = this.$props.userData.uid
          await db.ref(`users/${uid}/totals/all`)
          .transaction(function (current_value) {
						return (current_value || 0) + parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/monthly`)
          .transaction(function (current_value) {
						return (current_value || 0) + parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/daily`)
          .transaction(function (current_value) {
						return (current_value || 0) + parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/monthly/${new Date().getMonth()+1}-${new Date().getFullYear()}`)
          .transaction(function (current_value) {
						return (current_value || 0) + parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/daily/${new Date().getDate()}-${new Date().getMonth()+1}-${new Date().getFullYear()}`)
          .transaction(function (current_value) {
						return (current_value || 0) + parseFloat(l.total);
          });
        }
      } else if(lBack.order_status == 'Confirmed' && l.order_status != 'Confirmed' && l.order_status != 'Dispatch') {
        if(this.$props.userData){
          let uid = this.$props.userData.uid
          await db.ref(`users/${uid}/totals/all`)
          .transaction(function (current_value) {
						return (current_value || 0) - parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/monthly`)
          .transaction(function (current_value) {
						return (current_value || 0) - parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/daily`)
          .transaction(function (current_value) {
						return (current_value || 0) - parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/monthly/${new Date().getMonth()+1}-${new Date().getFullYear()}`)
          .transaction(function (current_value) {
						return (current_value || 0) - parseFloat(l.total);
          });
          await db.ref(`users/${uid}/totals/daily/${new Date().getDate()}-${new Date().getMonth()+1}-${new Date().getFullYear()}`)
          .transaction(function (current_value) {
						return (current_value || 0) - parseFloat(l.total);
          });
        }
      }
      
    },
    bulkStatusUpdate(){
      let ls = this.selectedLeads
      let s = this.newStatusForAll
      if(!s) return false
      let m = [];
      (async x=>{
        for (let i = 0; i < this.selectedLeads.length; i++) {
          const l = this.selectedLeads[i];
          let key = l.key
          // l.order_status = s
          // l.update_date = getCDate();
          // delete l.dialog
          // db.ref(`leads/${key}`)
          await store.collection('leads').doc(key)
          .update({
            order_status:s,
            update_date:getCDate()
          })
        }
        this.changestatusdialog = false
        this.$emit('snackbarNotification', `All Selected Leads Updated`, 'success')
        this.loading = false
        this.newStatusForAll = null
        this.selectedLeads = []
      })()
      
    },
    exportCSV(){
      let config = {
        quotes: false, //or array of booleans
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ",",
        header: true,
        newline: "\r\n",
        skipEmptyLines: false, //or 'greedy',
        columns: null //or array of strings
      }
      const flattenObject = (obj, prefix = '') =>
        Object.keys(obj).reduce((acc, k) => {
          const pre = prefix.length ? prefix + '.' : '';
          if (typeof obj[k] === 'object') Object.assign(acc, flattenObject(obj[k], pre + k));
          else acc[pre + k] = obj[k];
          return acc;
      }, {});
      let expArr = []
      this.selectedLeads.forEach(l=>{
        for (const key in l) {
          if (l.hasOwnProperty(key)) {
            const val = l[key];
            if(!val) {
              l[key] = ''
            }
          }
        }
        expArr.push(flattenObject(l))
      })
      var csv = Papa.unparse(expArr)
      var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      var csvURL =  null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, 'download.csv');
      }
      else {
        csvURL = window.URL.createObjectURL(csvData);
      }
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', 'download.csv');
      tempLink.click();
    },
    async deleteB() {
      if (this.selectedLeads.length == 0) return true;
      this.loading = true;
      (async x=>{
        for (let i = 0; i < this.selectedLeads.length; i++) {
          const lead = this.selectedLeads[i];
          let key = lead.key
          await store.collection('leads').doc(key).delete();
          let index = this.leads.findIndex(x => x.key === key)
          let fIndex = this.filteredLeads.findIndex(x => x.key === key)
          if(index != -1) this.leads.splice(index, 1); 
          if(index != -1) this.filteredLeads.splice(fIndex, 1); 
          // db.ref(`leads`)
          // .update({
          //   [lead.key]:null
          // })
          // .then(y=>{
          //   let index = this.leads.findIndex(x => x.key === key)
          //   let fIndex = this.filteredLeads.findIndex(x => x.key === key)
          //   if(index != -1) this.leads.splice(index, 1); 
          //   if(index != -1) this.filteredLeads.splice(fIndex, 1); 
          //   if (i == this.selectedLeads.length -1 ) {
          //     this.dialogs.delete = false
          //     this.loading = false
          //     this.selectedLeads = []
          //     this.getPagesNumber()
          //     this.updateVisible()
          //     this.$emit('snackbarNotification', `All Selected Deleted Successfully`, 'success')
          //   }
          // })
        }
        this.dialogs.delete = false
        this.loading = false
        this.selectedLeads = []
        this.getPagesNumber()
        this.updateVisible()
        this.$emit('snackbarNotification', `All Selected Deleted Successfully`, 'success')
      })()
    },
    goTo(path) {
      this.$router.push(path)
    },
    recordStatusDate(key, lead) {
      let l = this.selectedLeads.filter(x=> x.key == lead.key)[0]
      let status = l.order_status ? l.order_status.split(' ').join('_').toLowerCase() : null
      if(status){
        if(!this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline){
          this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline = {}
        }
        if(!this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline[status]) {
          this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline[status] = {}
        }
        this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline[status]['date'] = getCDate()
        this.selectedLeads.filter(x=> x.key == lead.key)[0].status_timeline[status]['agent'] = this.$props.userName
      }
    },
    checkNumberWAOneApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneTwo = l.phone_number_1
      return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
      .then(resp=>{
        return resp
      })
    },
    checkNumberWATwoApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneTwo = l.phone_number_2
      return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
      .then(resp=>{
        return resp
      })
    },
    checkNumberWAThreeApi(l){
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let phoneTwo = l.phone_number_3
      return axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${phoneTwo}&cc=${country.alpha2Code}`)
      .then(resp=>{
        return resp
      })
    },
    async updateWAnumbers(l){
      if(!l.phone_number_1 && !l.phone_number_2 && !l.phone_number_3) return true
      this.waLoading = true
      this.checkNumberWAOneApi(l)
      .then(resp=>{
        if(resp.data.corrected && resp.data.g.isValidNumber) {
        this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_1 = resp.data.corrected ? resp.data.corrected : null
        this.$emit('snackbarNotification', `Phone 1 Corrected`, 'success')
        } else {
          this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
        }
        if(l.phone_number_2) {
          this.checkNumberWATwoApi(l)
          .then(resp=>{
            if(resp.data.corrected && resp.data.g.isValidNumber) {
            this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_2 = resp.data.corrected ? resp.data.corrected : null
            this.$emit('snackbarNotification', `Phone 2 Corrected`, 'success')
            } else {
              this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
            }
            if(l.phone_number_3) {
              this.checkNumberWAThreeApi(l)
              .then(resp=>{
                if(resp.data.corrected && resp.data.g.isValidNumber) {
                this.selectedLeads.filter(x=> x.key == l.key)[0].phone_number_3 = resp.data.corrected ? resp.data.corrected : null
                this.$emit('snackbarNotification', `Phone 3 Corrected`, 'success')
                } else {
                  this.$emit('snackbarNotification', `${resp.data.message}`, 'error')
                }
                this.waLoading = false
              })
            } else {
              this.waLoading = false
            }
            
          })
        } else {
          this.waLoading = false
        }
      })
      
    },
    getBasePrice(lead, i){
      if(lead.ninja) {
        return true
      }
      let currRate = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
      if(!lead.order[i].price) return 0
      if(lead.order[i].price.includes(':')){
        let foffer = lead.order[i].price.split(':')[1]
        let convPrice = parseFloat(foffer)
        if(!lead.order[i].discount || lead.order[i].discount == '') {
          lead.order[i].discount = 0
        }
        let bp = (convPrice - ((lead.order[i].discount*convPrice)/100)) / parseFloat(currRate.usd)
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].baseprice = bp.toFixed(2)
      } else {
        let f = this.productsFullLoaded.filter(p => (p.item_name == lead.order[i].product||p.name_ar == lead.order[i].product))[0]
        let foffer = f[lead.order[i].price]
        let convPrice = parseFloat(foffer)
        if(!lead.order[i].discount || lead.order[i].discount == '') {
          lead.order[i].discount = 0
        }
        let bp = (convPrice - ((lead.order[i].discount*convPrice)/100))
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].baseprice = bp.toFixed(2)
      }
    },
    async getSetPrice(lead, i){
    let p = await axios.get(productApiUrl(`bysku/${lead.order[i].sku}`)).then(x=>x.data)
      console.log(p)
      console.log(lead, lead.currency_factor)
      console.log(lead.order[i].sku)
      if (  lead.order[i].sku && !lead.order[i].sku.includes('K.0') )  {
        if (
          p.vprices.length && p.vprices.filter(x=>x.country.id == lead.country_id).length 
          && p.vprices.filter(x=>x.country.id == lead.country_id).map(x=>parseFloat(x.value)).filter(x=>x>0).length
          ) {

          if(p.vprices.filter(x=>x.country.id == lead.country_id).length) {
            this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].price = parseFloat(p.vprices.filter(x=>x.country.id == lead.country_id)[0].value)
            if(lead.manjam) {
              this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].sold_price = parseFloat(p.vprices.filter(x => x.country.id == lead.country_id)[0].value) * 1 / lead.currency_factor
            }
            this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].total = parseFloat(lead.order[i].price) * 1/ lead.currency_factor
            this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].quantity++
            this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].quantity--
            console.log(p, lead, p.vprices.filter(x=>x.country.id == lead.country_id))

            await this.getNinjaTotal(lead)
          } else {
            this.$emit('snackbarNotification', `Item has no vendor price for this country`, 'error')
          }
        } 
        else {
          this.$emit('snackbarNotification', `Item vendor price is 0 for this country`, 'error')
        }
      } else if (lead.order[i].sku && lead.order[i].sku.includes('K.0')) {
        const current_item = this.selectedLeads.filter(x => x.key == lead.key)[0].order[i]
        this.selectedLeads.filter(x => x.key == lead.key)[0].order[i] = {...this.selectedLeads.filter(x => x.key == lead.key)[0].order[0]}
        this.selectedLeads.filter(x => x.key == lead.key)[0].order[i].sku = current_item.sku
        this.selectedLeads.filter(x => x.key == lead.key)[0].order[i].product = current_item.product
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].price = this.selectedLeads.filter(x=> x.key == lead.key)[0].order[0].price
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].total = this.selectedLeads.filter(x=> x.key == lead.key)[0].order[0].total / this.selectedLeads.filter(x=> x.key == lead.key)[0].order[0].quantity
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].quantity++
        this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].quantity--
        await this.getNinjaTotal(lead)
      } else {
        this.$emit('snackbarNotification', `Item has no vendor prices`, 'error')
      }
    },
    async addQuantityToNinjaItem(l, i) {
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity++
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity--
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity++
      await this.checkMinPrice(l)
    },
    async removeQuantityToNinjaItem(l, i) {
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity--
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity++
      this.selectedLeads.filter(x=> x.key == l.key)[0].order[i].quantity--
      await this.checkMinPrice(l)
    },
    async getNinjaTotal(l){
      return new Promise(async (res, rej)=>{
      let a = await axios.post(crmApiUrl('lead-crm-total'), l, {headers}).then(x=>x.data)
        console.log('getNinjaTotal', a)
        l.ninja_total = a.total
        // l.manual_total = a.total
        await this.checkMinPrice(l)
        l.ninja_total = a.total
        if(l.manjam) {
          l.items = l.order
        }
        // l.manual_total = a.total
        console.log(a)
        res(true)
      })
    },
    async removeProductFromOrder(l, i) {
      this.selectedLeads.filter(x=> x.key == l.key)[0].order.splice(i, 1)
      await this.getNinjaTotal(l)
    },
    async checkMinPrice(lead) {
      return new Promise(async(res, rej)=>{
        if(lead.order.map(x=>parseFloat(x.total)).filter(x=>x > 0).length != lead.order.length) {
          this.$emit('snackbarNotification', `An SKU is not available in this country`, 'success')
          if(!lead.manjam)  return true
        }
        console.log('lead sent to check min', lead)
        let a = await axios.post(crmApiUrl('lead-crm-check'), lead, {headers}).then(x=>x.data)
        console.log(a)
        this.$emit('snackbarNotification', `Min Total: ${a.total} ${lead.currency_symbol}`, 'success')
        this.selectedLeads.filter(x=> x.key == lead.key)[0].min_total = a.total
        this.selectedLeads.filter(x=> x.key == lead.key)[0].min_total = a.total
        this.selectedLeads.filter(x=> x.key == lead.key)[0].float_base_profit = a.order_calc.base_profit
        res(a)
      })
    },
    async getSKU(lead, i){
      let f = this.productsFullLoaded.filter(p => (p.item_name == lead.order[i].product||p.name_ar == lead.order[i].product))[0]
      this.selectedLeads.filter(x=> x.key == lead.key)[0].order[i].sku = f.sku
      if(lead.ninja) {
        await this.getSetPrice(lead, i)
      }
    },
    getProductNote(lead, i) {
      if(lead.order[i].product) {
        let f = this.productsFullLoaded.filter(p => (p.item_name == lead.order[i].product||p.name_ar == lead.order[i].product))[0]
        return f ? f.note : false
      } else {
        return false
      }
    },
    async getDialogProduct(lead, i) {
      let f = this.productsFullLoaded.filter(p => (p.item_name == lead.order[i].product||p.name_ar == lead.order[i].product))[0]
      // console.log(f)
      this.productDialogImage = f.img
      let p = await axios.get(productApiUrl(`bysku/${f.sku}`)).then(x=>x.data)
      //.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '')
      //.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '')
      this.productDialogAr = p.description_ar ? p.description_ar : null
      this.productDialogEn = p.description_en ? p.description_en : null
      this.productDialogSKU = f.sku
      this.productDialogNameAr = f.name_ar
      this.productDialogNameEn = f.name_en
    },
    validateBeforeWAProduct(lead) {
      let val = true
      if(!lead.name || lead.name == '') {
        val = false
        this.$emit('snackbarNotification', `Name is required`, 'error')
      }
      if(!lead.gender || lead.gender == '') {
        if(this.$props.userRole != 'admin') {
          val = false
          this.$emit('snackbarNotification', `Gender is required`, 'error')
        }
      }
      if(!lead.language || lead.language == '') {
        if(this.$props.userRole != 'admin') {
          val = false
          this.$emit('snackbarNotification', `Language is required`, 'error')
        }
      }
      if(!lead.company_code || lead.company_code == '') {
        val = false
        this.$emit('snackbarNotification', `Company Code is required`, 'error')
      }
      if(!lead.wa_number || lead.wa_number == '') {
        if(this.$props.userRole != 'admin') {
          val = false
          this.$emit('snackbarNotification', `WA Number is required`, 'error')
        }
      }
      return val
    },
    async sendProductToWA(lead){
      console.log(lead)
      if(!this.validateBeforeWAProduct(lead)) return
      //this.selectForEdit(lead)
      this.productsending = false
      this.dialogs.info = false
      let msgSettings = {
        arMale: {
          name:``,
          product:``,
          total:``,
          message: function(){ 
            return `عميلنا العزيز السيد ${this.name},\n\n`+
            `مواصفات المنتج:\n`+
            `${this.product}`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        arFemale:{
          name:``,
          product:``,
          total:``,
          message: function(){ 
            return `عميلتنا العزيزة السيدة ${this.name},\n\n`+
            `مواصفات المنتج:\n`+
            `${this.product}`+
            `اجمالي قيمة الطلب ${this.total}\n`+
            `نتمنى لكم يوما سعيدا.\n`+
            `فريق خدمة عملاء اشياءات.`
          }
        },
        enMale:{
          name:``,
          product:``,
          total:``,
          message:function(){
            return `Dear valued customer Mr. ${this.name},\n` +
            `Product Details:\n` +
            `${this.product}` +
            `Have a good day\n`+
            `Ashyaat customer service team.\n`
          }
        },
        enFemale:{
          name:``,
          product:``,
          total:``,
          message:function(){
            return `Dear valued customer Ms. ${this.name},\n` +
            `Product Details:\n` +
            `${this.product}` +
            `Have a good day\n`+
            `Ashyaat customer service team.\n` 
          }
        },
      }  
      if(lead.order.length != 0 
      && lead.language
      && lead.gender
      ){
        
        let msgObj = msgSettings[lead.language + lead.gender]
        msgObj.name = lead.name
        let product = {}
        product.ar =
        `${this.productDialogNameAr}\n`+
        `${this.productDialogAr.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '')}\n`
        product.en =
        `${this.productDialogNameEn}\n`+
        `${this.productDialogEn.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '')}\n`
        product.arTemplate =
        `${this.productDialogNameAr} | `+
        `${this.productDialogAr.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '').replace(/\n/g, ' | ')} | `
        product.enTemplate =
        `${this.productDialogNameEn} | `+
        `${this.productDialogEn.replace(/<\/?.+?>/ig, '').replace(/&nbsp;/g, '').replace(/\n/g, ' | ')} | `

        msgObj.product = product[lead.language]
        
        // console.log(msgObj)
        let lang_temp = lead.language == 'ar' ? 'ar' : 'en'
        let tem_text = product[lang_temp + 'Template']
        // console.log(tem_text)
        let splice_temp = tem_text.substring(0, 900)
        let template = {
          name:`product_details_all`,
          namespace:`b9796543_bcb1_4152_bd49_66173da70fd8`,
          language: lang_temp,
          components: [
            {
              "type": "header",
              "parameters": [
                {
                  "type": "image",
                  "image": {
				            "link": this.productDialogImage
                  }
                }
              ]
            },
            {
              "type": "body",
              "parameters": [
                {
                  "type": "text",
                  "text": lead.name
                },
                {
                  "type": "text",
                  "text": splice_temp
                }
              ]
            }
          ]
        }
        // console.log(JSON.stringify(template))
        // let post = {
        //   number:parseInt(lead.wa_number ? lead.wa_number : lead.phone_number_1),
        //   media: {
        //     url:this.productDialogImage,
        //     caption:msgObj.message()
        //   },
        //   country:lead.company_code,
        //   user:this.$props.userName,
        //   template
        // }
        // // console.log(post)
        // const headers = {
        //   'Accept': 'application/json'
        // }
        // try {
        //   let send = await axios.post(`//WA API//`, post, {headers:headers}).then(x=>x.data)
        //   this.loading = false
        //   if(send.success) {
        //     this.productsending = false
        //     this.sMessage = null
        //     this.file = null
        //     this.imgURL = null
        //     this.imgURLExt = null
        //     this.loading = false
        //     this.nNumber = null
        //     this.dialog = false
        //     this.loading = false
        //     this.dialogs.info = false
        //   } else if(send.qr){
        //     this.dialogs.qr = true
        //     this.loading = false
        //     this.qrCode = send.qr
        //     this.$emit('snackbarNotification', `Please scan ${send.number} QR code`, 'error')
        //   } else {
        //     this.productsending = false
        //     // console.log(send)
        //     this.$emit('snackbarNotification', `${send.message}`, 'error')
        //   }
        // } catch (error) {
        //   // console.log(error)
        // }
      } else {
        this.productsending = false
      }
    },
    async genPaymentLink(l, key){
      if(!l.payment_url){
        let a = await this.encrypt(key)
        l.payment_url = `https://ashyaatpayment.web.app/p/${a}`
      }
    },
    getTotal(l, key){
      if(l.ninja) {
        return l.base_total
      }
      if (!l.order || l.order.length == 0) return `0`
      console.log('getting total')
      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      l.total_converted = total.toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      this.genPaymentLink(l, l.key)
      return finalTotal
    },
    async getTotalAfterTax(l, key){
      if(l.ninja) {
        await this.getNinjaTotal(l)
        return l.base_total
      }
      if (!l.order || l.order.length == 0) return `0`
      // console.log('getTotalAfterTax')

      let currRate = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      if(!currRate) return `0`
      let totalBase = 0 
      if(l.order && Array.isArray(l.order)) {
        l.order.forEach(order=>{
          totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
        })
      }
      let total = totalBase * parseFloat(currRate.usd) 
      // console.log(l.delivery_fees)
      if(l.delivery_fees) {
        l.delivery_fees_converted = (parseFloat(l.delivery_fees) * parseFloat(currRate.usd)).toFixed(0)
        total += parseFloat(l.delivery_fees) * parseFloat(currRate.usd)
      }
      if (l.voucher) {
        total = total - (parseFloat(l.voucher.amount) * parseFloat(currRate.usd))
      }
      // console.log(total)
      let finalTotal = `${total.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code  : ''}`
      if(key){
        this.selectedLeads.filter(x=> x.key == key)[0].total = totalBase.toFixed(2)
      }
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      l.total_invoice = (totalBase + totalBase * parseFloat(taxRate)).toFixed(2)
      l.total_converted_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.total_invoice_converted = ((totalBase + totalBase * parseFloat(taxRate)) * parseFloat(currRate.usd)).toFixed(2)


      if(l.add_up) {
        if(l.add_up == 'add_vat_to_total') {
          if(l.manual_total) {
            l.add_up_to_total = (parseFloat(l.manual_total) / (1 - parseFloat(taxRate))) / parseFloat(currRate.usd)
          }
        } else if(l.add_up == 'add_25_to_total') {
          l.add_up_to_total = 6.66 + (parseFloat(l.manual_total)/ parseFloat(currRate.usd))
        } else if(l.add_up == 'add_50_to_total') {
          l.add_up_to_total = 13.33 + (parseFloat(l.manual_total)/ parseFloat(currRate.usd))
        } else {
          l.add_up_to_total = 0 + + (parseFloat(l.manual_total)/ parseFloat(currRate.usd))
        }
      }
      // console.log(l.add_up_to_total)

      if(!l.add_up && l.add_vat_to_total) {
        l.add_up_to_total = (parseFloat(l.manual_total) / (1 - parseFloat(taxRate))) / parseFloat(currRate.usd)
      }


      if(l.manual_total){
        const cal_total = l.total_converted_after_tax
        let manual = l.add_up_to_total ? l.add_up_to_total*parseFloat(currRate.usd) : parseFloat(l.manual_total)
        l.manual_discount = parseFloat((((cal_total - manual) / cal_total) * 100).toFixed(2))
        l.total_invoice = (manual / parseFloat(currRate.usd)).toFixed(2)
        l.total_invoice_converted = manual
      } else {
        l.manual_discount = 0
      }
      l.tax = (total * parseFloat(taxRate)).toFixed(2)
      l.currency = currRate.currencies ? currRate.currencies[0].code  : ''
      l.payment_cc = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0].alpha2Code
      let finalTotalwithTax = {
        total:`${l.manual_total ? l.add_up_to_total ? (l.add_up_to_total *  parseFloat(currRate.usd)).toFixed(2) : parseFloat(l.manual_total) : l.total_converted_after_tax} ${currRate.currencies ? currRate.currencies[0].code  : ''}`,
        tax:(total * parseFloat(taxRate)).toFixed(2)
      }
      
      this.$emit('snackbarNotification', `Tax: ${finalTotalwithTax.tax} | Total: ${finalTotalwithTax.total}`, 'success')

      return finalTotalwithTax
    },
    storeEnSubDistrict(key, l) {
      let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
      let cities = country ? country.cities : []
      if(cities) {
        let subs = cities.filter(x=>x.name == l.city && x.sub_district_ar == l.sub_district)
        if(subs.length) {
          l.sub_district_en = subs[0].sub_district_en
          // console.log(l)
          return l.sub_district_en = subs[0].sub_district_en
        }
      }
    },
    async decrypt(b) {
      let data = {
        text:b
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      return a.decrypted
    },
    async encrypt(b) {
      let data = {
        text:b,
        action:'encrypt'
      }
      let a = await axios.post(`${apiBase}/ashhash`, data, headers).then(x=>x.data)
      return a.encrypted
    },
    getFilterTotaluser(u){
      let allLeads = this.filteredLeads.filter(l => l.agent_name == u)
      let grandTotal = 0
      for (const key in allLeads) {
        if (allLeads.hasOwnProperty(key)) {
          const l = allLeads[key];
          if (l.order || l.order.length != 0) {
            let totalBase = 0 
            l.order.forEach(order=>{
              totalBase += parseFloat(order.baseprice) * parseFloat(order.quantity)
            })
            if(!isNaN(totalBase)) {
              grandTotal += totalBase
            }
          }
        }
      }
      return `${grandTotal.toFixed(2)}`
    },
    
    getFilterConfirmRateuser(u){
      let allLeads = this.filteredLeads.filter(l => l.agent_name == u)
      let grandCount = 0
      let confirmCount = 0
      for (const key in allLeads) {
        if (allLeads.hasOwnProperty(key)) {
          const l = allLeads[key];
          grandCount++
          if(l.order_status){
            if(l.order_status.toLowerCase() == 'confirmed' || l.order_status.toLowerCase() == 'dispatch') {
              confirmCount++
            }
          }
        }
      }
      return `${(confirmCount/grandCount*100).toFixed(2)}`
    },
    async loadNinjaSettings() {
      return new Promise(async (res, rej)=>{
        this.ninjaCurrencyFactors = await db.ref('settings/ninja_conversion').once('value').then(x=>x.val())
        res()
      })
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        for (const key in this.orderFields) {
          if (this.orderFields.hasOwnProperty(key)) {
            const item = this.orderFields[key];
            if(item.type == 'select' && item.items != 'products' && item.items != 'countries') {
              let ts = await db.ref(item.items).once('value').then(x=>x.val())
              for (const key in ts) {
                if (ts.hasOwnProperty(key)) {
                  const tm = ts[key];
                  let n = tm.name ? tm.item_name ? tm.item_name : tm.name : tm
                  if(tm.name){
                    n = tm.name
                  } else if(tm.item_name){
                    n = tm.item_name
                  } else {
                    n = tm
                  }
                  this[item.items+'Loaded'].push(n)
                  if(item.items == 'deliverystatuses'){
                    this[item.items+'Loaded'].push(tm.en)
                    this[item.items+'Loaded'].push(tm.ar)
                  }
                  if(item.items == 'countries'){
                    this.countriesFullLoaded.push(tm)
                    this[item.items+'Loaded'].push(tm.cioc)
                  }
                }
              }
            } else if(item.items == 'products') {
              // if(this.$props.beta){
                // let a = await db.ref('productsCore') 
                // .once('value').then(x=>x.val())
                // let k = Object.keys(a)
                // let b = Object.values(a).map((x, i)=>{return{...x, key:k[i]}})
                // this[item.items+'Loaded'] = [].concat(...b.map(x=>x.item_name)).concat(...b.map(x=>x.name_ar))
                // this.productsFullLoaded = b

                let laraProducts = await axios.get(productApiUrl('products-all')).then(x=>x.data.products)
                let laraSubs = await axios.get(productApiUrl('products-all')).then(x=>x.data.subs.map(x=>{return{...x,item_name:`${x.item_name} | SUB | ${x.sku}`}}))
                // console.log(laraProducts)
                let variants = [].concat(...laraProducts.filter(x=> x.variants.length).map(x=>x.variants.map(v=>{
                  return {
                    ...x,
                    var_true:true,
                    ...v,
                    item_name:v.name,
                  }
                })))
                .concat(...laraSubs.filter(x=> x.variants.length).map(x=>x.variants.map(v=>{
                  return {
                    ...x,
                    var_true:true,
                    ...v,
                    item_name:`${v.name} | SUB | ${v.sku}`,
                  }
                })))
                let short_new_products = []
                .concat(...laraProducts.map(x=>x.item_name))
                .concat(...laraProducts.map(x=>x.name_ar))
                .concat(...variants.map(x=>x.name))
                .concat(...laraSubs.map(x=>x.item_name))
                .concat(...laraSubs.map(x=>x.name_ar))
                let all = [...laraSubs, ...laraProducts, ...variants] // .filter(x=>!laraProducts.filter(y=> y.variants.length).map(y=>y.sku).includes(x.sku))
                let new_products = all.map(x=>{
                  return {
                    ...x,
                    img: x.image && x.image.url ? x.image.url : null,
                    prices: x.prices? x.prices.map(p=>{
                      return {
                        ...p,
                        country:p.country.name
                      }
                    }): []
                  }
                })
                // console.log('laraProducts variants', variants)
                // console.log('laraProducts short mapped', short_new_products.filter(x=>x && x.subvendor))
                // console.log('laraProducts mapped', new_products.filter(x=>x && x.subvendor)[0])
                // console.log('laraProducts mapped', new_products[0])
                this[item.items+'Loaded'] = short_new_products
                this.productsFullLoaded = new_products
                // console.log('loaded products', new_products)
              // } else {
              //   let a = await db.ref('products') 
              //   .once('value').then(x=>x.val())
              //   let k = Object.keys(a)
              //   let b = Object.values(a).map((x, i)=>{return{...x, key:k[i]}})
              //   this['productsLoaded'] = [...b.map(x=>{return {...x, item_name:x.item_name, name_ar:x.name_ar, sku:x.sku, img:x.img}})]
              //   this.productsFullLoaded = b
              // }
            } else if(item.items == 'countries') {
              let a = await axios
                .get(productApiUrl("countries-cities"), {
                  headers:{
                    "Content-Type": "application/json",
                  },
                })
                .then((x) => x.data)
                .catch((err) => console.log(err));
              let ts = a
                .filter((x) => x.cities && x.cities.length > 0)
                .map((c) => {
                  return {
                    ...c,
                    cities: c.cities.map((x) => {
                      return {
                        ...x,
                        country: a.filter((y) => y.id == x.id).length
                          ? a.filter((y) => y.id == x.id)[0].alpha2Code
                          : null,
                        en:  null,
                        city: x.name,
                        fees: x.fee,
                      };
                    }),
                  };
                });
              for (const key in ts) {
                if (ts.hasOwnProperty(key)) {
                  const tm = ts[key];
                  let n = tm.name ? tm.item_name ? tm.item_name : tm.name : tm
                  if(tm.name){
                    n = tm.name
                  } else if(tm.item_name){
                    n = tm.item_name
                  } else {
                    n = tm
                  }
                  this[item.items+'Loaded'].push(n)
                  if(item.items == 'countries'){
                    this.countriesFullLoaded.push(tm)
                    this[item.items+'Loaded'].push(tm.cioc)
                  }
                }
              }
            }
          }
        }
        res(true)
      })
    },
    getItems(key, lead, i) {
      let it = this.orderFields[key].items
      let compareDate = lead && lead.import_date ? lead.import_date : getCDate()
      // console.log(compareDate)
      if(it != 'prices' && it != 'cities' && it != 'users' && it != 'wanumbers' && it != 'products' && it != 'subdistricts') {
        return this[it+'Loaded']
      } else if (it == 'products') {
        if(lead && lead.order && lead.order[i] && lead.order[i].sku){
          console.log(this.productsFullLoaded)
          return this.productsFullLoaded.filter( x => x.active || x.end_sku_date < new Date(compareDate).getTime() )
          .filter(x=>{
            if(x.subvendor) {
              if(x.account_id == lead.account_id) {
                return x
              }
            } else {
              return x
            }
          })
        } else {
          console.log('get p')
          return this.productsFullLoaded.filter( x => x.active || x.end_sku_date < new Date(compareDate).getTime() )
            .filter(x => {
              if (x.subvendor && lead) {
                if (x.account_id == lead.account_id) {
                  return x
                }
              } else {
                return x
              }
            })
        }
      } else if (lead && lead.order && lead.order[i] && lead.order[i].product && it == 'prices') {
        // if(!this.$props.beta){
        //   let p = this.productsFullLoaded.filter(g=> g.item_name == lead.order[i].product || g.name_ar == lead.order[i].product)[0]
        //   let r = ['item_name', 'sku', 'import_date', 'description_ar', 'description_en', 'name_ar', 'name_en', 'img', 'warehouse']
        //   let prices = []
        //   for (const key in p) {
        //     if (p.hasOwnProperty(key) && r.indexOf(key) == -1 && typeof p[key] == 'string') {
        //       const price = p[key];
        //       let bp = (price!='') ? parseFloat(price) : 0
        //       let currRate = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
        //       if (currRate) {
        //         let fPrice = parseFloat(bp) * parseFloat(currRate.usd)
        //         let dPrice = `${fPrice.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code:''}`
        //         if (fPrice != 0){
        //           prices.push(`${key ? key.toUpperCase() : key}: ${dPrice ? dPrice.toUpperCase() : dPrice}`)
        //           prices.push(`${key}`)
        //         }
        //       } else {
        //         prices.push(`${key ? key.toUpperCase() : key}: ${price?price.toUpperCase():price}`)
        //         prices.push(`${key}`)
        //       }
        //     }
        //   }
        //   return prices
        // } else {
          let p = this.productsFullLoaded.filter(x=> x.sku == lead.order[i].sku)[0]
          let currRate = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
          if(p && p.prices) {
            let prices = p.prices.filter(price=>{
              if(price.country == "ALL") {
                return price
              } else {
                if (price.country && price.country.includes(currRate.name) || price.country && price.country.includes(currRate.cioc)) {
                  return price
                }
              }
            })
            .filter(price=>{
              let a = new Date(compareDate).getTime()
              let b = new Date(price.from).getTime()
              let c = new Date(price.to).getTime()
              if(a>=b && a<=c) {
                return price
              }
            })
            .map(x=>{
              let bp = (x.value!='') ? parseFloat(x.value) : 0
              if (currRate) {
                let fPrice = parseFloat(x.value) * parseFloat(currRate.usd)
                let dPrice = `${fPrice.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code:''}`
                if (fPrice != 0){
                  return `${x.name ? x.name.toUpperCase() : x.name}: ${dPrice ? dPrice.toUpperCase() : dPrice}`
                }
              } else {
                return `${x.name ? x.name.toUpperCase() : x.name}: ${x.value}`
              }
            }).concat(
              ...p.prices
              .filter(price=>{
                if(price.country == "ALL") {
                  return price
                } else {
                  if(price.country && price.country.includes(currRate.name) || price.country && price.country.includes(currRate.cioc)) {
                    return price
                  }
                }
              })
              .filter(price=>{
                let a = new Date(compareDate).getTime()
                let b = new Date(price.from).getTime()
                let c = new Date(price.to).getTime()
                if(a>=b && a<=c) {
                  return price
                }
              })
              .map(x=>{
                  let bp = (x.value!='') ? parseFloat(x.value) : 0
                  if (currRate) {
                    let fPrice = parseFloat(x.value) * parseFloat(currRate.usd)
                    let dPrice = `${fPrice.toFixed(2)} ${currRate.currencies ? currRate.currencies[0].code:''}`
                    if (fPrice != 0){
                      return `${x.name}`
                      // prices.push(`${x.name}`)
                    }
                  } else {
                    return `${x.name}`
                    // prices.push(`${x.name}`)
                  }
                }
              )
            )
            return prices
          }
        // }
      } else if (it == 'cities') {
        let country = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
        let cities = country ? country.cities : []
        if(cities) {
          let retCities = []
          for (const key in cities) {
            if (cities.hasOwnProperty(key)) {
              const element = cities[key];
                if(element && element.name) { 
                  retCities.push(element.name)
                }
            }
          }
          return retCities
        }
      } else if (lead.city && it == 'subdistricts') {
        let country = this.countriesFullLoaded.filter(x=> x.name == lead.country || x.cioc == lead.country)[0]
        let cities = country ? country.cities : []
        // console.log(cities)
        if(cities) {
          let subs = cities.filter(x=>x && x.name && x.name == lead.city)
          // console.log(subs)
          if(subs.length) {
            return subs.map(x=>x.sub_district_ar)
          }
        }
      } else if (it == 'users') {
        if (!lead.agent_name || lead.agent_name == '' || lead.agent_name == null || this[it+'Loaded'].filter(x=> x == lead.agent_name).length == 0) {
          this.selectedLeads.filter(x=> x.key == lead.key)[0].agent_name = this.$props.userName
          return this[it+'Loaded'].filter(x=> x == this.$props.userName)
        } else {
          if(this.$props.userRole == 'admin') {
            return this[it+'Loaded']
          }
          return this[it+'Loaded'].filter(x=> x == this.$props.userName || x == lead.agent_name)
        }
      } else if (it == 'wanumbers') {
        return []
      } else {
        return []
      }
    },
    addProductToOrder(l){
      this.selectedLeads.filter(x => x.key == l.key)[0].order.push({
        product: '',
        price: '',
        discount: 0,
        baseprice: '',
        quantity: 1
      })
      
    },
    uid(){
      return randomString(10, '#Aa')
    },
    async addNewOrder(oldLead=false){
      this.selectedLeads = []
      let location = await db.ref('leads')
      .push()
      //let key = this.uid()
      await store.collection('leads').doc(location.key).set({key:location.key})
      let lead = {}
      for (let i = 0; i < this.basicFields.length; i++) {
        const field = this.basicFields[i];
        lead[field] = ''
      }
      let nKesys = ['order_status', 'order', 'note', 'update_date', 'address']
      nKesys.forEach(key=>{
        if ( typeof lead[key] === 'undefined' && key != 'order') 
        lead[key] = null
        if(typeof lead[key] === 'undefined' && key == 'order')
        lead[key] = []
      })
      if(oldLead) {
        let { name, country, city, address, phone_number_1, phone_number_2, address_url, wa_number, gender, language, campaign_code, country_id, city_id, account_id, business_name, cc, company_code, ninja, en_city, integration_id, user_id, free_delivery, currency_symbol, without_delivery } = oldLead
        lead = { name, country, city, address, phone_number_1, phone_number_2, address_url, wa_number, gender, language, campaign_code, country_id, city_id, account_id, business_name, cc, company_code, ninja, en_city, integration_id, user_id, free_delivery, currency_symbol, without_delivery }
        lead.items = []
        lead.order = []
        lead.manjam = true
        lead.order_status = 'Confirmed'
        lead.order_source = 'Manjam'
        lead.note = 'Manjam Order'
        lead.currency_factor = 1/ this.ninjaCurrencyFactors[lead.cc.toUpperCase()]
        console.log(lead)
      }
      lead.date = getCDate()
      lead.import_date = getCDate()
      lead.new = true
      lead.key = location.key
      lead.creator_agent = this.$props.userName
      console.log(lead)
      this.selectedLeads.push(lead)
      this.dialogs.editing = true;
    },
    async getDBfilter(){
      return new Promise(async (res, rej)=>{
        this.countries = [
          "KSA",
          "Saudi Arabia",
          "SA",
          "Bahrain",
          "BH",
          "Palestine",
          "Kuwait",
          "KW",
          "Libya",
          "LY",
          "JO",
          "Jordan",
          "UAE",
          "AE",
          "United Arab Emirates",
          "OM",
          "Oman",
          "Iraq",
          "IQ",
          "PS",
          "Qatar",
          "Lebanon",
          "Senegal",
          "QA",
          "LB",
          "SN",
          "MR",
          "Côte d'Ivoire",
          "CI",
          "Mauritania",
          "MA",
          "Morocco",
          "EG",
          "Egypt",
          "YE",
          "Yemen",
        ]
        this.campaigns = await db.ref(`settings/dbfilters/campaigns`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
        this.referrers = await db.ref(`settings/dbfilters/referrers`).once('value').then(x=>x.val())
        this.companycodes = await db.ref(`settings/dbfilters/companycodes`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
        this.searchCats = await db.ref(`settings/dbfilters/searchCats`).once('value').then(x=>x.val())
        this.tokensLoaded = await db.ref(`settings/dbfilters/tokens`).once('value').then(x=>x.val())
        this.DataStatLoading  = false
        this.loading = false
        res(true)
      })
    },
    async getAdminFilter(){
    },
    getBaseTotal(l){
      if(l.ninja) {
        return l.base_total
      }
      let total = 0
      let ftaxRate = this.taxrates.filter(x=> x.country == l.country)
      let taxRate = ftaxRate.length ? ftaxRate[0].rate : 0
      for (let i = 0; i < l.order.length; i++) {
        const item = l.order[i];
        total += parseFloat(item.baseprice) * parseFloat(item.quantity)
      }
      l.total_after_tax = (total + total * parseFloat(taxRate)).toFixed(2)
      l.total_amount = l.paid ? l.online_total : l.total_after_tax
      return l.total_amount
    }, 
    async loadDateLock(){
      return new Promise(async (res, rej)=>{
        this.minDate = await db.ref('settings/lockdate').once('value').then(x=> new Date(x.val()).toISOString().split('T')[0])
        res(true)
      })
    },
    async getTaxRates(){
      return new Promise(async (res, rej)=>{
         let a = await db.ref(`taxrates`).once('value').then(x=>x.val())
        this.taxrates = Object.values(a)
        res(true)
      })
    },
    async checkSecPhone(l, phone) {
      return new Promise(async (resolve, reject)=>{
        let country = this.countriesFullLoaded.filter(x=> x.name == l.country || x.cioc == l.country)[0]
        let corrected = phone
        if(phone) {
          phone = phone.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
            return d.charCodeAt(0) - 1632;                
          }).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) { return d.charCodeAt(0) - 1776; })
        }
        let m = await axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/ash_phone/vPhone?phone=${encodeURI(phone)}&cc=${country.alpha2Code}`)
        .then(resp=>resp)
        if(m.data.corrected && m.data.g && m.data.g.isValidNumber) {
          phone = m.data.corrected ? m.data.corrected.slice(3, m.data.corrected.length) : phone
          resolve(phone) 
        } else {
          resolve(false) 
        }
      })
    },
    async switchNumbers(l) {
      if(!l.switched) {
        if(await this.checkSecPhone(l, l.phone_number_2)) {
          let a = l.phone_number_1
          let b = l.phone_number_2
          l.phone_number_2 = a
          l.phone_number_1 = b
          l.switched = true
          l.new_switch = true
        } else {
          this.$emit('snackbarNotification', `Wrong Second Number`, 'error')
        }
      } else {
        this.$emit('snackbarNotification', `Switched Already`, 'error')
      }
    },
    async loadItemsManual(){
      // await this.sleep(10*1000)
      // console.log('manual load')
      await this.getDBfilter()
      await this.loadDateLock()
      await this.getSettings()
      await this.getTaxRates()
    }
  },
  watch: {
    selectedLeads(){
      // console.log('------------------------------------');
      console.log(this.selectedLeads);
      // console.log('------------------------------------');
    },
    dialogSearch(){
      if(this.$props.dialogSearch) {
        this.dialogs.embed = true
      } else {
        this.dialogs.embed = false
      }
    },
    editLeadEmbed(){
      if(this.$props.editLeadEmbed) {
        this.visibleLeads.push(...this.$props.editLeadEmbed)
      } else {
        this.visibleLeads = []
      }
    }
  },
  props: {
    dialogSearch:{default:false},
    editLeadEmbed:{default:false},
    embed:{default:false},
    userName: {
      required: true,
      default: null
    },
    userImage: {
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
    userData: {
      required: true,
    },
  },
  async created() {
    
    
    auth.onAuthStateChanged(user => {
      if (user) {
        db.ref(`users/${user.uid}`)
        .on('value', snap=>{
          if (snap.val()) {
            let x = snap.val()
            if(x.superadmin) {
              this.DataStatLoading = false
              // this.getDataStats()
            } else if(x.role == 'admin') {
              this.DataStatLoading  = false
              this.loading = false
              // this.getDataStats()
            } else {
            }
          }
        })
      }
    });
    this.loadItemsManual()
    
    //console.log('uid', this.$props.userData.uid)
    
    // db.ref('settings/orderFields')
    // .update({
    //   address:{
    //     type:'textarea',
    //     order:4
    //   },
    //   agent_name: {
    //     type:'select',
    //     items:'users',
    //     order:23
    //   },
    //   wa_number: {
    //     type:'select',
    //     items:'wanumbers',
    //     order:11
    //   },
    //   campaign_code:{
    //     type:'select',
    //     items:'campaigns',
    //     order:18
    //   },
    //   cancel_note: {
    //     type:'textarea',
    //     order:14
    //   },
    //   city: {
    //     type:'select',
    //     items:'cities',
    //     order:3
    //   },
    //   address_url:{
    //     type:'textfield',
    //     order:6
    //   },
    //   // sub_district: {
    //   //   type:'select',
    //   //   items:'subdistricts',
    //   //   order:6
    //   // },
    //   country: {
    //     type:'select',
    //     items:'countries',
    //     order:2
    //   },
    //   customer_id:{
    //     type:'textfield',
    //     order:16
    //   },
    //   date: {
    //     type:'textfield',
    //     order:20
    //   },
    //   email:{
    //     type:'textfield',
    //     order:25
    //   },
    //   shipping_status:{
    //     type:'select',
    //     items:'shippingstatuses',
    //     order:26
    //   },
    //   document_number:{
    //     type:'textfield',
    //     order:27
    //   },
    //   payment_url:{
    //     type:'textfield',
    //     order:28
    //   },
    //   delivery_status:{
    //     type:'select',
    //     items:'deliverystatuses',
    //     order:29
    //   },
    //   failed_delivery_after_payment:{
    //     type:'select',
    //     items:'faileddeliverystatuses',
    //     order:30
    //   },
    //   online_total:{
    //     type:'textfield',
    //     order:30
    //   },
    //   no_alternative:{
    //     type:'check',
    //     order:31
    //   },
    //   // quantity:{
    //   //   type:'textfield',
    //   //   order:9
    //   // },
    //   note:{
    //     type:'textarea',
    //     order:15
    //   },
    //   product: {
    //     type:'select',
    //     items:'products',
    //     order:10
    //   },
    //   price: {
    //     type:'select',
    //     items:'prices',
    //     order:11
    //   },
    //   baseprice: {
    //     type:'select',
    //     items:'baseprices',
    //     order:23
    //   },
    //   item_name:{
    //     type:'textarea',
    //     order:5
    //   },
    //   // item_name_cross_sell:{
    //   //   type:'textarea',
    //   //   order:6
    //   // },
    //   update_date:{
    //     type:'textfield',
    //     order:22
    //   },
    //   creator_agent:{
    //     type:'textfield',
    //     order:24
    //   },
    //   name:{
    //     type:'textfield',
    //     order:1
    //   },
    //   gender:{
    //     type:'select',
    //     items:'genders',
    //     order:12
    //   },
    //   language:{
    //     type:'select',
    //     items:'languages',
    //     order:13
    //   },
    //   dispatch_date:{
    //     type:'date',
    //     order:14
    //   },
    //   import_date:{
    //     type:'textfield',
    //     order:21
    //   },
    //   vendor_note:{
    //     type:'textarea',
    //     order:32
    //   },
    //   order_source:{
    //     type:'select',
    //     items:'sources',
    //     order:17
    //   },
    //   order_status:{
    //     type:'select',
    //     items:'orderstatuses',
    //     order:10
    //   },
    //   phone_number_1:{
    //     type:'textfield',
    //     order:7
    //   },
    //   phone_number_2:{
    //     type:'textfield',
    //     order:8
    //   },
    //   phone_number_3:{
    //     type:'textfield',
    //     order:9
    //   },
    //   company_code:{
    //     type:'select',
    //     items:'companies',
    //     order:19
    //   },
    // })
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style>

.smallerScaleCheck {
  flex:none;
}
.tokenField * {
  color:white !important;
}
.map {
  width: 100vw;
  height: 69vh;
}
.customInfo {
  left: 5%;
  position: absolute;
  bottom: 210px;
  z-index: 40;
  background: #fff;
}
</style>
